/*
| Rank | Setup           | Priority        |Price Down 
| ---- | --------------- | -------- -------|
| 1    | Retest Breakout | ⭐⭐⭐⭐⭐    |
| 2    | Sector Ranked   | ⭐⭐⭐⭐⭐    |
| 3    | Slight Increase | ⭐⭐⭐⭐⭐    |
| 4    | GCO             | ⭐⭐⭐⭐⭐    |
| 5    | Accumulation    | ⭐⭐⭐⭐⭐    |
| 6    | Uptrend         | ⭐⭐⭐⭐      | 
--------------------------------------------
| 7    | Bulk            | ⭐⭐⭐⭐      | Price Up
| 8    | EMA Crossover   | ⭐⭐⭐        |
| 9    | Retracement     | ⭐⭐⭐        |
| 10   | Retracement Z   | ⭐⭐          |


| $belowBreakoutSetups = ['Retest Breakout', 'Sector Ranked', 'GCO', 'Uptrend', 'Slight Increase'];
| $aboveBreakoutSetups = ['EMA Crossover', 'Bulk', 'Retracement', 'Retracement Z', 'Accumulation', 'Accumulation T'];


| Setup           | Buy Logic                          | Why                        | Target
| --------------- | ---------------------------------- | -------------------------- |----------------- 
| Retest Breakout | Close                              | Strong setup               | T1 = 3R only
| Sector Ranked   | Close                              | Strong sector leader       | T1 = 2R, T2 = 3R, T3 = 5R
| Slight Increase | Close                              | Strong setup               | T1 = 3R only
| GCO             | Close                              | Early trend start          | T1 = 2R, T2 = 3R, T3 = 5R
| Uptrend         | EMA20 + 1%                         | Pullback entry             | Previous High, then 3R, then Trail
-------------------------------------------------------------------------------------------------------------------------
| Accumulation    | High + 0.5%                        | Breakout confirmation      | T1 = 2R, T2 = 4R, T3 = Trail EMA20
| EMA Crossover   | Close above crossover candle high  | Momentum confirmation      | T1 = 2R, T2 = 3R, T3 = 5R
| Bulk            | Close above Bulk Day High          | Institutional confirmation | T1 = 2R, T2 = 3R, T3 = Previous ATH
| Retracement     | 38.2%-50% retracement zone         | Buy dip in trend           | Previous High, then 3R
| Retracement Z   | 50%-61.8% retracement zone         | Deep pullback              | Previous High, then 3R


*/

import React, { useState, useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getSymbolList,
  getGoogleSheet,
  getMyTrendSetup,
  setuplistItemDelete,
  setuplistItemUpdate,
  getDeliveryPercentList,
  getIntrdaySetup,
  getIndicesActivity,
  getSectorRotationByRanked,
  getLeadingSectors
} from "../action/api-services";
import StockAction from "../component/stockAction";
import moment from "moment";
import PageLoader from "../component/loader";
import DeliveryGraph from "../component/deliveryGraph";
import SectorPanchang from "../component/sectorPanchag";
import StockStrength from "../component/stockStrength";
import { AIPromptForStock1, AIPromptForStockPL, calculateLeaderScore, diffDays, getFairBuyPrice, NSE_Current_date, todayMarketHoldTime, todayMarketSentiment } from "../utils/constants";
import { useNavigate } from "react-router-dom";
import infoIcon from "../assets/images/info-icon.svg"
import iconupArrow from "../assets/images/icon-up-arrow.svg"
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TodayPLGraph from "../component/todayPLGraph";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { setDeliveryDataReducer } from "../redux/slice/deliveryData";
import { isFarFromEMA20, normalize } from "../utils/utilsFunctions";




const TrendsSetupPage = () => {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [todayTime, setTodayTime] = useState();
  const [todayData, setTodayData] = useState([]);
  const [symbolData, setSymbolData] = useState([]);
  const [intradayData, setIntradayData] = useState([]);
  const [getSectorsList, setSectorsList] = useState([]);
  const [setupData, setSetupData] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [getUniqueDates , setUniqueDates] = useState([]);
  const [getUniqueSetups , setUniqueSetups] = useState([]);
  const [todaysetupStatus, setTodaysetupStatus] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [trends, setTrends] = useState("All");
  const [type, setType] = useState("Default");
  const [series, setSeries] = useState("EQ");
  const [currentSort, setCurrentSort] = useState(false);
  const [maxDate, setMaxDate] = useState();
  const [isTodayBreakout, setIsTodayBreakout] = useState(false);
  const [toastShown, setToastShown] = useState('');
  
  
  const userToken = useSelector((state) => state.userToken.value);
  // const [deliveryDataList = useSelector((state) => state.deliveryData.value);
  const [deliveryDataList, setDeliveryDataList] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [paramsMeta, setParamsMeta] = useState([]);
  const [symbolInBasket, setSymbolInBasket] = useState([]);
  const [verified, setVerified] = useState(false);
  const [unverified, setUnverified] = useState(false);
  const [nearest, setNearest] = useState(false);
  const [breakout, setBreakout] = useState(false);
  const [rejected, setRejected] = useState(false);
  const [currentMonth, setCurrentMonth] = useState(false);
  const [pastMonth, setPastMonth] = useState(false);  
  const [portfolio, setPortfolio] = useState(false);
  const [score, setScore] = useState(false);
  const [achieveTarget, setAchieveTarget] = useState(false); 

  
  const [newBuyPrice, setNewBuyPrice] = useState(0);
  const [newSLPrice, setNewSLPrice] = useState(0);
  const [newTargetPrice, setNewTargetPrice] = useState(0);
  const [newNotes, setNewNotes] = useState('');
  const [verifyDate, setVerifyDate] = useState();
  const [verifyPrevDate, setVerifyPrevDate] = useState();
  const [showData, setShowData] = useState(window.innerWidth <= 768 ? false:true);

  const [getMonthPL, setMonthPL] = useState([]);

// console.log('startDate: ', moment(startDate).format('YYYY-MM-DD'))

const isWeekdayAllowed = (date) => {
    const day = date.getDay();    
    date.setDate(date.getDate() - 1);        
    const excludeDate = date.toISOString().split("T")[0];
    
    return day !== 0 && day !== 6; // Exclude weekends and holidays
    // return day !== 0 && day !== 6 && !YearHolidays.includes(excludeDate);
  };

  const navigate = useNavigate();

  useEffect(() => {
          if (userToken){
              setLoader(true);
              Promise.all([
                  getGoogleSheet("", userToken),
                  getSymbolList(series, '', userToken),
                  getMyTrendSetup(userToken),
                  getIntrdaySetup({date: moment(NSE_Current_date).format('YYYY-MM-DD')}, userToken),
                  getDeliveryPercentList('', 'setups', '', '', series, '', userToken), // setups
                  // getSectorRotationByRanked({date: moment(NSE_Current_date).format('YYYY-MM-DD'), type : 'Indices'}, userToken)
                  getLeadingSectors(userToken)
                ])
                .then(([googleRes, symbolRes, setupRes, intraday, delivery, indices]) => {
                  setMaxDate(googleRes.data.data.datetime);
                  setTodayTime(googleRes.data.data.datetime);
                  setTodayData(googleRes.data.data.json_data);
                  setSymbolData(symbolRes.data.data || []);
                  setSectorsList(indices.data.week || []);
                  // setSetupData(setupRes.data.data);

                  setIntradayData(intraday.data.data || []);
                  setDeliveryDataList(delivery.data.data || []);
                  dispatch(setDeliveryDataReducer(delivery.data.data || []));

                  let deliveyData = delivery.data.data || [];
                  let todayData = googleRes.data.data.json_data || [];

                  let result = Array.isArray(setupRes?.data?.data)
                              ? setupRes.data.data
                                  // .filter(item => parseFloat(item.breakout_price) > 100)
                                  .map(item => {
                                          const deliveryList = Object.values(delivery?.data?.data || {});
                                          const dd = deliveryList.find(d => d.symbol === item.symbol);
                                          const td = todayData.find(t => t.TICKER === item.symbol);
                                          const scoreData = {
                                                ...dd,
                                                RSI: dd?.RSI || 0,
                                                ADX: dd?.ADX || 0,
                                                delivery_per: dd?.stock_data?.[0]?.delivery_per || 0,
                                                prev_delivery_per: dd?.stock_data?.[1]?.delivery_per || 0,
                                                ttl_trd_qty: dd?.stock_data?.[0]?.ttl_trd_qty || 0,
                                                prev_volume: dd?.stock_data?.[1]?.ttl_trd_qty || 0,
                                            };
                                      return {
                                          ...item,
                                          LTP: td.LTP,
                                          todayScore: calculateLeaderScore(scoreData)
                                      };
                                  })
                              : [];

                              
                            // ################## For Month PL #################

                              let targetPL = 0;
                              let slPL = 0;
                              let targetQty = 0;
                              let slQty = 0;
                              let upcomingPL = 0;
                              let upcomingQty = 0;

                              result.forEach((item) => {
                                  const triggeredDate = new Date(item.triggered_date);
                                  const now = new Date();
                                  
                                  const isCurrentMonth =
                                      triggeredDate.getMonth() === now.getMonth() &&
                                      // triggeredDate.getMonth() === now.getMonth() - 1 &&
                                      triggeredDate.getFullYear() === now.getFullYear();

                                  const buyPrice = Number(item.buy_price);
                                  const todayLTP = Number(item.LTP);
                                  const triggeredPrice = Number(item.triggered_price);
                                  const quantity = Number(item.quantity || item.qty || 1);
                                  const UPquantity = Number(item.quantity || item.qty || 1);

                                  // UPCOMING
                                  if (
                                      Number(item.verified) === 1 &&
                                      item.is_triggered === "" &&
                                      Number(item.buy_price) > 0 &&
                                      todayLTP > 0
                                  ) {
                                    const UPplPercent =   ((todayLTP - buyPrice) / buyPrice) * 100;
                                    upcomingPL += UPplPercent;
                                    upcomingQty += UPquantity;
                                  }

                                 if (!isCurrentMonth || buyPrice <= 0) return;

                                  const plPercent =   ((triggeredPrice - buyPrice) / buyPrice) * 100;

                                  // TARGET
                                  if (Number(item.verified) === 1 && item.is_triggered === "TARGET") {
                                      targetPL += plPercent;
                                      targetQty += quantity;
                                  }

                                  // STOPLOSS
                                  if (Number(item.verified) === 1 && item.is_triggered === "STOPLOSS") {
                                      slPL += plPercent;
                                      slQty += quantity;
                                  }
                              });

                              const totalPL = targetPL + slPL;

                              const plSummary = {
                                  target: Number(targetPL.toFixed(2)),
                                  targetQty,

                                  sl: Number(slPL.toFixed(2)),
                                  slQty,

                                  total: Number(totalPL.toFixed(2)),
                                  totalQty: targetQty + slQty,

                                  upcoming: Number(upcomingPL.toFixed(2)),
                                  upcomingQty
                              };
                              setMonthPL(plSummary);
                            // ################## For Month PL #################



                  setSetupData(result);

                })
                .catch(console.error)
                .finally(() => setLoader(false));
          } else {
                navigate(`/`);
          }

  }, [userToken]);


  useEffect(() => {
        if (!setupData?.length) {
          return;
        }


        // let  todayDate = moment(maxDate).format('YYYY-MM-DD');
        // const uniqueDates = [...new Set(
        //   setupData.map(item => item.breakout_date)
        // )].sort((a, b) => new Date(b) - new Date(a));

        const todayDate = moment(maxDate).format('YYYY-MM-DD');
        const uniqueDates = [
          ...new Set([
            ...setupData.map(item => item.breakout_date),
            todayDate
          ])
        ].sort((a, b) => new Date(b) - new Date(a));

        
        setUniqueDates(uniqueDates);

        const setupOrder = {
          'Retest Breakout' : 1,
          'Sector Ranked'   : 2,
          'Pullback'        : 3,
          'EMA Crossover'   : 4,
          'Slight Increase' : 5,     
          'Bulk'            : 6,     
          'GCO'             : 7,
          'Uptrend'         : 8,                    
          'Sector Rotation' : 9,          
        };

        const uniqueSetups = [...new Set(
          setupData.map(item => item.setup)
        )].sort((a, b) => (setupOrder[a] ?? 999) - (setupOrder[b] ?? 999));

        setUniqueSetups(uniqueSetups);

  }, [setupData]); 

 useEffect(() => {
      if (!getUniqueDates.length) return;

      setStartDate(prev => {
        // First page load → auto select first date
        if (prev === null) return getUniqueDates?.[0] || "All";
        if (prev === "All") return prev;
        if (getUniqueDates.includes(prev)) return prev;
        return getUniqueDates?.[0] || "All";
      });



        let todayNear = setupData?.map((obj) => {
                        let symbolName = obj.symbol;
                        let todayLTP = todayData?.find((s) => s.TICKER === symbolName);
                        let deliverylist = Object.values(deliveryDataList);
                        let deliveryData = deliverylist?.find((s) => s.symbol === symbolName);
                        if (!todayLTP) return null;

                        let ltp = parseFloat(todayLTP.LTP);
                        let breakoutPrice = parseFloat(obj.breakout_price);
                        let nearPercent =  Math.abs(((ltp - breakoutPrice) / breakoutPrice) * 100);
                        let todayType = null;

                        let Volume = parseInt((moment(todayTime).isSame(todayLTP?.DATE, 'day')) && todayMarketHoldTime() === true? todayLTP?.VOLUME: deliveryData?.stock_data?.[0]?.ttl_trd_qty);
                        let Prev_Volume = parseInt((moment(todayTime).isSame(todayLTP?.DATE, 'day')) && todayMarketHoldTime() === true? deliveryData?.stock_data?.[0]?.ttl_trd_qty:deliveryData?.stock_data?.[1]?.ttl_trd_qty);
                        let cuurVolPer = ((Volume - Prev_Volume) * 100) / Prev_Volume;

                        let prevDeliv = deliveryData?.stock_data?.[1]?.delivery_per;
                        let deliv = deliveryData?.stock_data?.[0]?.delivery_per;

                        // TodaysMomentum FIRST
                        const isRetracement = ['Retracement', 'Retracement Z'].includes(obj.setup);
                        if (parseInt(obj.is_buy) === 0 
                          && moment(obj.today_momentum).isSame(startDate, 'day')
                          // && obj.todayScore > 65 
                          // && cuurVolPer > 25 
                          // && deliv > prevDeliv 
                          && !isRetracement) {
                          todayType = 'TodaysMomentum';
                        }
                        
                        // Breakout
                        if (
                             moment(obj.buy_date).isSame(startDate, 'day') ||
                             moment(obj.triggered_date).isSame(startDate, 'day')
                           ) {
                            todayType = 'Breakout';
                        }

                        // Near to breakout
                        if (nearPercent <= 1 && parseInt(obj.is_buy) === 0 && (moment(obj.breakout_date).isSameOrBefore(moment(startDate), 'day'))) {
                            todayType = 'NearToBreakout';
                        }


                        // Buy GTT
                        if (parseInt(obj.is_buy_GTT) === 1) {
                            todayType = 'BuyGTT';
                        }

                        


                        // 40 Days Exceeded from buy date
                        // obj.in_portfolio === '1' && 
                        if (parseInt(obj.is_buy) === 1 && obj.is_triggered ==='' && parseFloat(obj.triggered_price) === 0.00) {
                          
                          let days = diffDays(moment(obj.buy_date).format('YYYY-MM-DD'), getUniqueDates?.[0]);
                          if(days >= 38){
                              // console.log("days", days, obj);
                              todayType = 'DaysExceeded';
                          }
                          
                        
                        }

                        // final filter
                        if (
                          obj.verified === '1' &&
                          // obj.is_triggered === '' &&
                          todayType
                        ) {
                          return {
                            ...obj,
                            todayType,
                            ltp,
                            nearPercent: nearPercent.toFixed(2),
                          };
                        }

                        return null;

                        })
                        ?.filter(Boolean)
                        ?.reduce((acc, item) => {
                            acc[item.todayType].push(item);
                            return acc;

                          },
                          {
                            Breakout: [],
                            NearToBreakout: [],
                            TodaysMomentum: [],
                            BuyGTT:[],
                            DaysExceeded: [],
                          }
                        );

          setTodaysetupStatus(todayNear);
          // console.log(">>>>>", getUniqueDates?.[0], todayNear)

}, [getUniqueDates, startDate]);


useEffect(() => {
  let date = moment(NSE_Current_date).format('YYYY-MM-DD');
  if (startDate && moment(startDate).isValid()) {
      date = moment(startDate).format('YYYY-MM-DD');
  }
    getIntrdaySetup({date: date}, userToken)
      .then(function (response) {
        setIntradayData(response.data.data || []);
      })
      .catch(function (err) {
        console.log("Error", err);
    });

    if(moment(startDate).isBefore(moment(), 'day')){
      // getSectorRotationByRanked({date: moment(date).format('YYYY-MM-DD')}, userToken)
      getLeadingSectors(userToken)
        .then(function (response) {
            setSectorsList(response.data.week || []);    
        })
        .catch(function (err) {
          console.log("Error", err);
      });
    }

    // if(moment(startDate).isBefore(moment(), 'day')){
    //   getDeliveryPercentList(moment(date).format('DDMMYY'), 'setups', userToken)
    //     .then(function (response) {
    //       setDeliveryDataList(response.data.data || []);    
    //       dispatch(setDeliveryDataReducer(response.data.data || []));    
    //     })
    //     .catch(function (err) {
    //       console.log("Error", err);
    //   });
    // }


}, [startDate, userToken])


  const filteredData = useMemo(() => {
    if (!setupData?.length) return [];
    return startDate === "All"
      ? setupData
      : setupData.filter(i => i.breakout_date === startDate);

  }, [setupData, startDate]);




const filteredMarketPL = useMemo(() => {
  const today = getUniqueDates?.[0] //moment().format("YYYY-MM-DD");
  const list = Object.values(todayData || {});

  // if (!moment(startDate).isSame(today, 'day') || !Array.isArray(list)) return [];  


  if (startDate === "All" || moment(startDate).isSame(today, 'day')) {

      let { PScore, LScore } = list
                              .filter(obj =>
                                symbolData.some(s =>
                                  s.symbol === obj.TICKER &&
                                  parseInt(s.active) === 1 &&
                                  s.series === 'EQ'
                                )
                              )
                            .reduce(
                              (acc, row) => {
                                if (Number(row.CHANGEPER) >= 0) {
                                  
                                  acc.PScore += 1;
                                } else {
                                  acc.LScore += 1;
                                }
                                return acc;
                              },
                              { PScore: 0, LScore: 0 }
                            );
      let total = PScore + LScore;
      let bullishPercent = total ? ((PScore / total) * 100).toFixed(2) : 0;
      let bearishPercent = total ? ((LScore / total) * 100).toFixed(2) : 0;
      return {PScore, LScore, total, bullishPercent, bearishPercent}
  }

  let { PScore, LScore} = list
    .filter(stock =>
        symbolData.some(s =>
          s.symbol === stock.symbol &&
          parseInt(s.active) === 1 &&
          s.series === 'EQ'
      )
    )
    .flatMap(stock =>  stock.stock_data.filter( row => row.delivery_date === startDate))
    .reduce((acc, row) => {
        if (Number(row.chn_per) >= 0) {
          acc.PScore += 1;
        } else {
          acc.LScore += 1;
        }
        return acc;
      },
      { PScore: 0, LScore: 0 }
    );

    let total = PScore + LScore;
    let bullishPercent = total ? ((PScore / total) * 100).toFixed(2) : 0;
    let bearishPercent = total ? ((LScore / total) * 100).toFixed(2) : 0;

    // console.log(PScore, LScore, total, bullishPercent, bearishPercent);
    return {PScore, LScore, total, bullishPercent, bearishPercent}


}, [startDate, todayData, symbolData]);


const handleControll = () =>{
    setShowData((prev) => !prev);
}

const handleSearch = (e) => {
  setSearchText(e);
};


  const filteredTrend = useMemo(() => {
        if (!filteredData?.length) return [];
        let result = trends === "All"
          ? filteredData
          : filteredData.filter(i => i.setup === trends);


        // Exclude ETF and BOND series
        result = result.filter(
          item =>
            item.series !== "ETF" &&
            item.series !== "BOND"
        );

        if (searchText.length >= 2) {
          result = setupData?.filter((item) => item.symbol?.toLowerCase().includes(searchText.toLowerCase()));
        }

        if(portfolio){
            const ltpMap = Object.fromEntries(todayData.map(s => [s.TICKER, Number(s.LTP)]));
            result = result.filter(item => Number(item.in_portfolio) === 1 && item.is_triggered ==='' && item.setup === item.portfolio_setup)
            .sort((a, b) => {

                  const aLTP = ltpMap[a.symbol] ?? 0;
                  const bLTP = ltpMap[b.symbol] ?? 0;

                  const aBreakoutPrice = Number(a.breakout_price) || 0;
                  const bBreakoutPrice = Number(b.breakout_price) || 0;

                  const aPL = aBreakoutPrice > 0
                      ? ((aLTP - aBreakoutPrice) / aBreakoutPrice) * 100
                      : 0;

                  const bPL = bBreakoutPrice > 0
                      ? ((bLTP - bBreakoutPrice) / bBreakoutPrice) * 100
                      : 0;

                  return bPL - aPL;
              });
        }

        if(score){
            result = result.filter(item => Number(item.todayScore) > 60 && item.is_triggered ==='')
            .sort((a, b) =>  b.todayScore - a.todayScore );
        }

        if(achieveTarget){
            result = result.filter(item => Number(item.is_buy) === 1 && item.is_triggered !=='')            
            .sort((a, b) =>  a.triggered_date - b.triggered_date );
        }

        

        if (verified) {
          result = result.filter(item => Number(item.verified) === 1 && item.is_triggered ==='');
        }

        if (unverified) {
          result = result.filter(item => Number(item.verified) !== 1 && item.is_triggered ==='');
        }

        if (breakout) {
          result = result.filter(item => Number(item.is_buy) === 1 && item.is_triggered ==='' 
              // && item.buy_date === getUniqueDates?.[0]
           ).sort((a, b) => new Date(b.buy_date) - new Date(a.buy_date));
        }

        if(rejected){
          result = result.filter(item => Number(item.reject_stock) === 1);
        }

        if (currentMonth) {
            result = result.filter(item => {
                const triggeredDate = new Date(item.triggered_date);
                const buyDate = new Date(item.buy_date);
                const now = new Date();

                const isCurrentMonth =
                    (triggeredDate.getMonth() === now.getMonth() && triggeredDate.getFullYear() === now.getFullYear())
                    // || (buyDate.getMonth() === now.getMonth() && buyDate.getFullYear() === now.getFullYear())
                    ;

                const buyPrice = Number(item.buy_price);

                return isCurrentMonth && buyPrice > 0;
            });
        }
        
        if (pastMonth) {
            result = result.filter(item => {
                const triggeredDate = new Date(item.triggered_date);
                const buyDate = new Date(item.buy_date);
                const now = new Date();

                const previousMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
                const isPastMonth = triggeredDate.getFullYear() === previousMonth.getFullYear() && triggeredDate.getMonth() === previousMonth.getMonth();

                const buyPrice = Number(item.buy_price);

                return isPastMonth && buyPrice > 0;
            });
        }


        if (nearest) {

                const ltpMap = Object.fromEntries(todayData.map(s => [s.TICKER, Number(s.LTP)]));
                 result = result.map(item => {
                      // FIXED
                      const LTP = ltpMap[item.symbol] ?? 0;
                      const breakoutPrice = Number(item.breakout_price);
                      const diffPct = ((LTP - breakoutPrice) / breakoutPrice) * 100;

                      let deliverylist = Object.values(deliveryDataList);
                      let deliveryData = deliverylist?.find((s) => s.symbol === item.symbol);

                      let NearEMA = isFarFromEMA20(LTP, deliveryData?.EMA20)?.ema_distance ?? 999;
                        return {
                            ...item,
                            LTP,
                            // NearEMA,
                            EMAAbs: Math.abs(NearEMA),
                            diffPct,
                            diffAbs: Math.abs(diffPct)
                        };

                  })

                  // FILTER
                  .filter(item =>{
                      return (
                          // item.breakout_date !== getUniqueDates?.[0] &&
                          item.is_triggered === "" &&
                          parseInt(item.is_buy) === 0 &&
                          // // item.diffAbs <= 1
                          item.EMAAbs <=15 &&
                          item.todayScore > 60
                      );
                    }
                  )
                  .sort((a, b) =>
                      a.diffAbs - b.diffAbs
                  );
          }

        return result;

  }, [filteredData, trends, searchText, score, portfolio, breakout, nearest, achieveTarget, verified, unverified, rejected, currentMonth, pastMonth]);


  
  

    const dataSortBy = (filterType, sortby) => {
        setCurrentSort(sortby);
        if(filterType === "symbol"){
              if(currentSort === true){
                filteredTrend.sort((a, b) => {
                    return a.symbol.localeCompare(b.symbol); // Sorting alphabetically by symbol
                });
              }else{
                filteredTrend.sort((a, b) => {
                    return b.symbol.localeCompare(a.symbol); // Sorting alphabetically by symbol
                });
              }
        }
        else if(filterType === "buy"){          
                  filteredTrend.sort((a, b) => {

                    const aTriggered = !!a.is_triggered;
                    const bTriggered = !!b.is_triggered;

                    // Empty is_triggered first
                    if (aTriggered !== bTriggered) {
                        return aTriggered ? 1 : -1;
                    }

                      const getValues = (obj) => {
                          let todayLTP = todayData?.find((s) => s.TICKER === obj.symbol);
                          let LTP = todayLTP?.LTP ?? 0;

                          let deliverylist = Object.values(deliveryDataList);
                          let deliveryData = deliverylist?.find((s) => s.symbol === obj.symbol);

                          let NearEMA = isFarFromEMA20(todayLTP?.LTP, deliveryData?.EMA20)?.ema_distance;

                          let diffPct = ((LTP - obj.breakout_price) / obj.breakout_price) * 100;

                            
                          return { NearEMA, diffPct };
                      };

                      let A = getValues(a);
                      let B = getValues(b);

                      // First priority → EMA Distance %
                      // return currentSort ? B.NearEMA - A.NearEMA : A.NearEMA - B.NearEMA;

                      // Second priority → actual diff %
                      return currentSort ? A.diffPct - B.diffPct : B.diffPct - A.diffPct;
                  });

        }


        else if(filterType === "sector"){
              filteredTrend.sort((a, b) => {

                      const aDetails =
                          symbolData?.find(
                              (s) => s.symbol === a.symbol
                          );

                      const bDetails =
                          symbolData?.find(
                              (s) => s.symbol === b.symbol
                          );

                      const aSector =
                          aDetails?.group_sector || '';

                      const bSector =
                          bDetails?.group_sector || '';

                      return currentSort
                          ? aSector.localeCompare(bSector)
                          : bSector.localeCompare(aSector);
                  });
        }

        else if(filterType === "setup"){
              if(currentSort === true){
                filteredTrend.sort((a, b) => {
                    return a.setup.localeCompare(b.setup); // Sorting alphabetically by setup
                });
              }else{
                filteredTrend.sort((a, b) => {
                    return b.setup.localeCompare(a.setup); // Sorting alphabetically by setup
                });
              }
        }
        else if(filterType === "score"){
              if(currentSort === true){
                filteredTrend.sort((a, b) => {
                    return a.todayScore - b.todayScore; // Sorting alphabetically by setup
                });
              }else{
                filteredTrend.sort((a, b) => {
                    return b.todayScore - a.todayScore; // Sorting alphabetically by setup
                });
              }
        }




    };
      

    const editItemHandler = (e, obj, openModal) => {
      setNewBuyPrice(obj.breakout_price);
      setNewSLPrice(obj.sl_price);
      setNewTargetPrice(obj.target_price);
      setNewNotes(obj.notes);

      setVerifyDate(obj.breakout_date);
      setVerifyPrevDate(obj.breakout_date);

        if(openModal){
            setModalShow(true);
        }

        setParamsMeta(obj);
        const pastBasket = setupData
                 .filter(item => item.symbol === obj.symbol)
              // .filter(item => item.symbol === obj.symbol && !(item.breakout_date === obj.breakout_date && item.setup === obj.setup))
              // .filter(item => item.symbol === obj.symbol && item.breakout_date !== obj.breakout_date && item.setup !== obj.setup)
              .sort((a, b) => new Date(b.breakout_date) - new Date(a.breakout_date));
        setSymbolInBasket(pastBasket);

    }

    const checkInputVal = (event) =>{
              setToastShown('');
              const char = event.key;
              const currentValue = event.currentTarget.value;

              if (!/[\d.]/.test(char)) {
                event.preventDefault();
              }

              if (char === '.') {
                if (currentValue.includes('.') || currentValue === '') {
                  event.preventDefault();
                }
              }
    }


    const removeItemHandler = (e, id) => {
      e.preventDefault();
      let params = {
        item_id: id,
      };
      setuplistItemDelete(params, userToken)
        .then(function (response) {
          if (response.data.status === true) {
            setSetupData(prev => prev.filter(item => item.id !== id));
            toast.success(response.data.message);
            const element = document.getElementById("item_id_" + id);
            if (element) {
              element.remove();
              const rows = document.querySelectorAll("table.symbolInBasket tbody tr");
              if(rows.length === 0){
                setModalShow(false);
              }
            }
          } else {
            toast.error(response.data.message);
          }
        })
        .catch(function (err) {
          console.log("Error", err);
        });
    };

    
    const updateHandlerType = (e) =>{
        const { name, checked } = e.target;
        if (name === 'todayBreakout') {
            setIsTodayBreakout(true);
            checked?setVerifyDate(getUniqueDates[0]):setVerifyDate(verifyPrevDate);
            document.getElementById('resetPrice').checked = false;
        } else {
            setIsTodayBreakout(false);
            document.getElementById('todayBreakout').checked = false;
        }
        e.target.checked = checked;
    }



    const updateItemHandler = (e, item) => {
        e.preventDefault();
        const form = e.target;
        // console.log(form.elements.rejectStock.checked)
        // const gttupdate = form.elements.forgttupdate.checked ? true : false;
        
        if(parseFloat(newSLPrice) >=  parseFloat(newBuyPrice)){
          setToastShown(`SL Amount ${newSLPrice} should be less than buy price ${newBuyPrice}`);
          return false;
        }
        if(parseFloat(newTargetPrice) <=  parseFloat(newBuyPrice) ){
          setToastShown(`GTT Amount ${newTargetPrice} should be greater than buy price ${newBuyPrice}`);
          return false;
        }

       
        if (moment(verifyDate).isBefore(moment(todayTime).subtract(2, 'days'), 'day') &&
            parseInt(item.verified) === 0 && item.verified_date === '0000-00-00'
        ) {
            toast.error("Verify date must be within 2 days of the breakout date.");
            // return false;
        }
        let todayScore = item.todayScore;
        let params = {
              item_id: item.id,
              symbol: item.symbol,
              setup: form.elements.mtrends.value,
              breakout_price: form.elements.buyprice.value,
              breakout_date: form.elements.todayBreakout.checked ? moment(verifyDate).format("YYYY-MM-DD") : item.breakout_date,
              sl_price: form.elements.sl.value,
              target_price: form.elements.target.value,
              notes: form.elements.notes.value,
              verified: form.elements.resetPrice.checked === true ? 0 : 1,
              verified_date: form.elements.resetPrice.checked === true ? '0000-00-00' : moment(verifyDate).format("YYYY-MM-DD"),
              addNew: form.elements.todayBreakout.checked && item.is_triggered !=="" && parseInt(item.is_buy) === 1? true:false,
              isTodayBreakout: form.elements.todayBreakout.checked? true:false,
              resetPrice: form.elements.resetPrice.checked,
              rejectStock : form.elements.rejectStock.checked,
              buyGTT : parseInt(item.is_buy) === 1 ? form.elements.buyGTT.checked : false
        };


      
        setuplistItemUpdate(params, userToken)
          .then(function (response) {
            // console.log("response", response)
            if (response.data.status === true) {

              // const newRecord = response.data.data[0];
              // setParamsMeta(obj);
              const newRecord = {
                  ...response.data.data[0],
                  todayScore
              };

                  setSymbolInBasket(prev => {
                      const exists = prev.some(item => item.id === newRecord.id);
                      return exists
                        ? prev.map(item => item.id === newRecord.id ? newRecord : item)
                        : [newRecord, ...prev];
                    });

                    setSetupData(prev => {
                      const exists = prev.some(item => item.id === newRecord.id);
                      return exists
                        ? prev.map(item => item.id === newRecord.id ? newRecord : item)
                        : [newRecord, ...prev];
                    });


              toast.success(response.data.message);
              
            } else {
              toast.error(response.data.message);
            }
          })
          .catch(function (err) {
            console.log("Error", err);
          });
    };  


  let triggerStats = {};
  let triggerCount = 0;
  let triggerSLCount = 0;
  let triggerTGCount = 0;
  let totalTarget = 0;
  let totalSL = 0;
  let upcomingPL = 0;
  let upcomingPLCount = 0;

useEffect(() => {
  
  if(type !== "Default"){
      setStartDate("All");
      setTrends("All");
  } else{
      setStartDate(getUniqueDates?.[0]);
  }
  setVerified(type === "Verified");
  setUnverified(type === "Unverified");
  setNearest(type === "Nearest");
  setBreakout(type === "Breakout");
  setPortfolio(type === "Portfolio");
  setScore(type === "Score")
  setAchieveTarget(type === "AchieveTarget");
  setRejected(type === "Rejected");
  setCurrentMonth(type === "CurrentMonth");
  setPastMonth(type === "PastMonth");  
}, [type]);



const isSameDate = (d1, d2) =>   moment(d1).isSame(d2, "day");
  // moment(d1).format("YYYY-MM-DD") === moment(d2).format("YYYY-MM-DD");



  return (
    <React.Fragment>
      <div className="pageContainer">
        <React.Fragment>
          <div className="container-fluid actionControler pb-3">
            <div className="row"><div className="col-12 pb-1">
                <strong>938179</strong> | 
                Leader: {getSectorsList?.leaders?.join(', ')}  | 
                Upcoming: {getSectorsList?.upcoming?.join(', ')}
              </div></div>
            <div className="row">
              {showData &&
              <>
              <div className="col-md-2 col-sm-6 pe-md-0 mb-2 mb-md-0">
                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control"
                    id="symbolSearch"
                    placeholder="Search"
                    onKeyUp={(e) => handleSearch(e.target.value)}
                  />
                  <label htmlFor="symbolSearch">Search</label>
                </div>
              </div>              

              <div className="col-md-2 col-sm-6 pe-md-0 mb-2 mb-md-0">
                <div className="form-floating">
                  <select
                    className="form-control"
                    id="dates"
                    value={startDate}
                    onChange={e => setStartDate(e.target.value)}
                  >
                    <option value="All">All</option>

                    {getUniqueDates?.map((item, index) => (
                      <option key={item} value={item}>
                        {`${moment(item).format("DD-MM-YYYY")} ${
                            index > 0
                              ? `- ${String(index + 1).padStart(2, "0")} [${diffDays(item, new Date())} ${index > 1? 'Days':'Day'}]`
                              : ""
                          }`}                          
                      </option>
                    ))}
                  </select>
                  <label htmlFor="dates">Date</label>
                </div>
              </div>

              <div className="col-md-2 col-sm-6 mb-2 mb-md-0 pe-md-0">
                <div className="form-floating">
                  <select
                    className="form-control"
                    id="trends"
                    value={trends}
                    onChange={e => setTrends(e.target.value)}
                  >
                    <option value="All">All</option>
                    {getUniqueSetups?.map((item) => (
                      <option key={item} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                  <label htmlFor="trends">Trends</label>
                </div>
              </div>
              {trends && trends !== "All" && (

              
              <div className="col-auto px-0 relative infowrap">
                <img src={infoIcon} width={`30px`} className="mt-1 ms-2" />
                    <div className="infowrapTxt"
                        dangerouslySetInnerHTML={{
                          __html: (() => {

                            switch (trends) {

                              case "Angle":
                                return `
                                  <h5>Angle</h5>
                                  <ul>
                                    <li key="ang_1">Days: 50</li>
                                    <li key="ang_2">Structure: UPTREND, BULLISH_CHOCH</li>
                                    <li key="ang_3">Angle5 > 25</li>
                                    <li key="ang_4">Angle10 > 20</li>
                                    <li key="ang_5">Angle15 > 15</li>
                                    <li key="ang_6">Angle20 > 10</li>
                                    <li key="ang_7">Angle5 > Angle10</li>
                                    <li key="ang_8">RSI > 30 && RSI < 70</li>
                                    <li key="ang_9">TrueAvgVolume === 1</li>
                                    <li key="ang_10">ATR > 5</li>
                                    <li key="ang_11">Close Price > Open Price</li>
                                    <li key="ang_12">Close Price > SMA20</li>
                                    <li key="ang_13">SMA50 > SM200</li>
                                  </ul>
                                `;

                              case "Slight Increase":
                                return `
                                  <h5>Slight Increase</h5>
                                  <ul>
                                    <li key="sli_1">Days: 50</li>
                                    <li key="sli_2">Structure: UPTREND, BULLISH_CHOCH</li>
                                    <li key="sli_3">Delivery Strength: > 0.02</li>
                                    <li key="sli_4">Volume Strength: > 0.02</li>
                                  </ul>
                                `;

                              case "Ascending Triangle":
                                return `
                                  <p>Triangledsfsdaf sdaf sadf sdaf sdaf dsf sdfsa</p>
                                `;

                              default:
                                return '';

                            }

                          })()
                        }}
                      />
                    </div>
              )}

              <div className="col-12 col-md-2 relative pe-md-0 mb-2 mb-md-0">
                  <div className="form-floating">
                  <select
                    className="form-control"
                    id="type"
                    value={type}
                    onChange={e => setType(e.target.value)}
                  >
                    <option value="Default">Default</option>
                    <option value="Score">Score</option>
                    <option value="Portfolio">Portfolio</option>
                    <option value="Breakout">Breakout</option>
                    <option value="Nearest">Nearest EMA</option>
                    <option value="AchieveTarget">Achieve Target</option>
                    <option value="Verified">Verified</option>
                    <option value="Unverified">Unverified</option>
                    <option value="Rejected">Rejected</option>
                    <option value="CurrentMonth">Month</option>
                    <option value="PastMonth">Past Month</option>
                  </select>
                  <label htmlFor="type">Type</label>
                </div>
              </div>
              </>
              }
              <div className="col">
                {window.innerWidth > 768?
              <div
                className={`form-control TodayPLDisplay ${
                  moment(maxDate).format("YYYY-MM-DD") ===
                  moment(startDate === "All" || startDate === moment(maxDate).format("YYYY-MM-DD") ? maxDate : startDate).format("YYYY-MM-DD")
                    ? "currentDate"
                    : ""
                }`}
                style={{
                  backgroundColor:
                    filteredMarketPL.PScore > filteredMarketPL.LScore
                      ? "#f3fff9"
                      : "#fff6f6",
                }}
              >
                <div className="todayPL">
                  {startDate === "All" || startDate === moment(maxDate).format("YYYY-MM-DD") ? moment(maxDate).format("DD-MM-YYYY HH:mm A") : moment(startDate).format("DD-MM-YYYY")}
                  {" — "}
                  <span style={{ color: "#28c87d" }}>{filteredMarketPL.PScore}</span>/
                  <span style={{ color: "#fa5a5a" }}>{filteredMarketPL.LScore}</span> | {" "} {filteredMarketPL.total}
                  


                  <a style={{position: 'absolute', right: '0px', top: '5px'}} 
                     title="Totay S"
                     className="newsicon"
                     href={`https://www.google.com/ai?q=${todayMarketSentiment()}`}
                     target="_blank"
                     rel="noopener noreferrer"
                  ></a>

                </div>
                {moment(maxDate).format("YYYY-MM-DD") ===
                moment(startDate === "All"? maxDate : startDate).format("YYYY-MM-DD") ? (
                  <TodayPLGraph series={'EQ'} />
                ) : (
                  ""
                )}
              </div>
              :<div className="d-flex justify-content-end">
                    <button  
                      onClick={(e) => handleControll()}
                      className="btn p-0 px-4 border-0 bg-transparent">
                        <img src={iconupArrow} style={{width:'20px', height:'auto'}} />
                      </button></div>}
            </div>

            </div>
          </div>

          
          {loader === true? (
            <PageLoader />
          ) : (
            <div className="pagewrap" style={{paddingBottom:130}}>
              
              <>
                  <table className="increaseOI table-responsive">
                    <thead>
                      <tr key={`item_0`}>
                        <th style={{ width: "65px" }}>{startDate === "All"? "Date": "Time"}</th>
                        <th style={{ width: "115px" }}>
                          Symbol [
                          {`${filteredTrend?.length}${
                            startDate !== "All" ? `/${filteredData?.length}` : ""
                          }`}]

                          <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('symbol', !currentSort)}}></button>
                        </th>
                        <th style={{ width: "15px" }}></th>
                        <th style={{ width: "42px" }}></th>
                        <th style={{ width: "50px", textAlign: "left"}}>Strength</th>
                        <th style={{ width: "105px", textAlign: "left"}}>Sector <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('sector', !currentSort)}}></button></th>
                        <th style={{ width: "62px", textAlign: "left"}}>Score <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('score', !currentSort)}}></button></th>
                        <th style={{ width: "55px", textAlign: "left"}}>Indices</th>
                        <th style={{ width: "100px", textAlign: "left"}}>Setup <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('setup', !currentSort)}}></button></th>
                        <th style={{ width: "85px", textAlign: "left"}}>Structure</th>
                        <th style={{ width: "15px", textAlign: "left"}}>M</th>
                        <th style={{ width: "55px" }}>Buy <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('buy', !currentSort)}}></button></th>
                        <th style={{ width: "55px" }}>SL</th>
                        <th style={{ width: "55px" }}>Target</th>
                        <th style={{ width: "55px" }}>Close</th>
                        <th style={{ width: "68px" }}>LTP [{moment(todayTime).format("HH:mm")}]</th>
                        <th style={{ width: "45px" }}>Chn%</th>
                        <th style={{ width: "55px" }}>T Chn%</th>
                        <th style={{ width: "42px" }}>EMA20</th>
                        <th style={{ width: "42px" }}>SMA50</th>
                        <th style={{ width: "60px" }}>Down 52</th>
                        <th style={{ width: "110px" }}>52 L/H</th>
                        <th style={{ width: "75px" }}>Vol</th>
                        <th style={{ width: "48px" }}>Del%</th>
                        <th style={{ width: "60px" }}>News</th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* For Today Trends List */}
                      {filteredTrend.length > 0?
                          filteredTrend?.map((obj, index) => {
                            // console.log(obj);
                            let symbolName = obj.symbol;
      

                            let details = symbolData?.find((s) => s.symbol === symbolName);
                            let todayLTP = todayData?.find((s) => s.TICKER === symbolName);
                            
                            let deliverylist = Object.values(deliveryDataList);
                            let deliveryData = deliverylist?.find((s) => s.symbol === symbolName);
                            let EMA21Cross = parseFloat(deliveryData?.EMA20) > parseFloat(deliveryData?.SMA20);                        
                            
                            
                            let high52w = details?.high52w? details?.high52w: 0;
                            let low52w = details?.low52w? details?.low52w: 0;
                            let highDate = details?.highDate? moment(details?.highDate).format("DD-MM-YY"): "";
                            let lowDate = details?.lowDate? moment(details?.lowDate).format("DD-MM-YY"): "";
                            // let Structure = JSON.parse(obj?.structure_json || '[]');
                            let Structure = deliveryData?.structure_json || [];   
                            let momentum_type = deliveryData?.momentum_type;   

                            let setup_buy_price = parseFloat(obj.portfolio_buy_price !== null? obj.portfolio_buy_price: obj.buy_price);
                            
                            let tchn_per = obj.is_triggered === "TARGET"?  
                                ((obj.triggered_price - setup_buy_price) * 100) / setup_buy_price :

                                obj.is_triggered === "STOPLOSS"?  
                                ((obj.triggered_price - setup_buy_price) * 100) / setup_buy_price : 0
                  

                            let is_SLHits =  parseInt(obj.is_buy) === 1 && obj.is_triggered === "STOPLOSS"? true:false;
                            let is_TargetHits = obj.is_buy === "1" && obj.is_triggered === "TARGET"? true:false;
                            

                            const setup = obj.setup || "UNKNOWN";
                            if (!triggerStats[setup]) {
                                    triggerStats[setup] = {
                                      stopLossCount: 0,
                                      targetCount: 0,
                                      total: 0,
                                      totalSL: 0,
                                      totalTarget: 0,
                                      upcomingPL: 0
                                    };
                            }

                            
                            if(is_SLHits){
                                triggerStats[setup].stopLossCount += 1;
                                triggerStats[setup].total += 1;
                                triggerCount = triggerCount + 1;
                                triggerSLCount = triggerSLCount + 1;
                                triggerStats[setup].totalSL += ((obj.triggered_price - setup_buy_price) * 100) / setup_buy_price;
                            }

                            if(is_TargetHits){
                                triggerStats[setup].targetCount += 1;
                                triggerStats[setup].total += 1;
                                triggerCount = triggerCount + 1;
                                triggerTGCount = triggerTGCount + 1;
                                triggerStats[setup].totalTarget += ((obj.triggered_price - setup_buy_price) * 100) / setup_buy_price;
                            }
                            if(obj.is_buy === "1" && obj.is_triggered === ""){
                              triggerStats[setup].upcomingPL += ((parseFloat(todayLTP?.LTP) - setup_buy_price) * 100) / setup_buy_price;
                              upcomingPLCount = upcomingPLCount + 1;
                            }
                            
                            
                            let rchn_per = parseFloat(setup_buy_price) > 0 ? ((todayLTP?.LTP - setup_buy_price) * 100) / setup_buy_price : ((todayLTP?.LTP - obj.breakout_price) * 100) / obj.breakout_price;
                          
                            let high52wPer = (((high52w - todayLTP?.LTP) * 100) / high52w);

                            let Volume = parseInt((moment(todayTime).isSame(todayLTP?.DATE, 'day')) && todayMarketHoldTime() === true? todayLTP?.VOLUME: deliveryData?.stock_data?.[0]?.ttl_trd_qty);
                            let Prev_Volume = parseInt((moment(todayTime).isSame(todayLTP?.DATE, 'day')) && todayMarketHoldTime() === true? deliveryData?.stock_data?.[0]?.ttl_trd_qty:deliveryData?.stock_data?.[1]?.ttl_trd_qty);

                            
                            let cuurVolPer = ((Volume - Prev_Volume) * 100) / Prev_Volume;

                            let prevDeliv = deliveryData?.stock_data?.[1]?.delivery_per;
                            let deliv = deliveryData?.stock_data?.[0]?.delivery_per;

                            let days = diffDays(moment(obj.buy_date).format('YYYY-MM-DD'), moment(obj.triggered_date).format('YYYY-MM-DD'));

                            // console.log("obj", obj)

                            return (
                              <tr
                                className={`tr_${details?.id}`}
                                key={`row_item_${obj.id}`}
                                id={`row_item_${obj.id}`}
                              >
                              <td style={{fontSize:'11px'}} title={startDate === "All"? moment(obj.datetime).format('HH:mm A'): ''}>{startDate === "All" || searchText.length > 0? moment(obj.breakout_date).format("DD-MM-YY") : moment(obj.datetime).format('HH:mm A')}</td>
                              <td 
                                  className={`symbolName ${obj.in_portfolio === '1' && obj.is_triggered ===''? 'inpotfolio':''} ${obj.in_portfolio === '0' && obj.in_watchlist ==='1'? 'inwatchlist':''}`} 
                                style={{borderLeft: obj.verified === '1'? "3px solid #FF9800" : '', background: obj.today_occurred === moment().format('YYYY-MM-DD') && obj.occurance > 2? '#d3ffd5':''}}
                                title={(obj.today_occurred === moment().format('YYYY-MM-DD') && obj.occurance > 2? `[Occurance ${obj.occurance}] | ` : '')  +  (obj.in_portfolio === '1' && obj.is_triggered ===''? `Bought at: ${ moment(obj.portfolio_buy_date).format('DD-MM-YYYY')} - ${obj.portfolio_buy_price} [${obj.unit_qty}] ${obj.demat}` :  '')}
                          >
                                  {symbolName}{" "}
                                  {details?.hotStar === "1" ? (
                                    <span className="hotStar"></span>
                                  ) : null}

                                  {details?.current_star === "1" ? (
                                    <span className="currStar"></span>
                                    ) : null}

                                    <span className="gttaction">
                                      {parseInt(obj.gtt_SL) === 1 && <span className="gttSL"></span>}
                                      {parseInt(obj.gtt_Target) === 1 && <span className="gttTarget"></span>}
                                    </span>
                                </td>
                                <td>
                                  <StockAction
                                    symbol={symbolName}
                                    delivery={false}
                                    currentPrice={obj?.breakout_price}
                                    deliveryPer={obj.delivery_per}
                                    hotStar={details?.hotStar}
                                    myFev={details?.myFev}
                                    eventName={obj.setup}
                                    slPrice={obj.sl_price}
                                    gttPrice={obj.target_price}
                                    rowId={`row_item_${obj.id}`}
                                    score = {obj.score}
                                  />
                                </td>
                                <td>
                                  <DeliveryGraph
                                    symbol={symbolName}
                                    todayLTP={todayLTP}
                                    date={getUniqueDates?.[0]}
                                  />
                                </td>
                                <StockStrength
                                  id={`del_${obj.id}`}
                                  selectedDate={todayTime}
                                  symbol={symbolName}
                                  todayLTP={todayLTP}
                                  details={details}
                                  // predictions={obj.prediction}
                                />
                                <SectorPanchang
                                  symbol={symbolName}
                                  sector={details?.group_sector}
                                  todayData={todayData}
                                  symbolData={symbolData}
                                  tag = "td"
                                  align = "right"
                                  durationDays = ""
                                />
                                <td title={obj.score} style={{ textAlign: "left", background: obj?.todayScore > 70 ? "#72d083": obj?.todayScore > 60 ? "#ffec9c": "" }}>
                                    {obj?.todayScore}
                                  </td>
                                <td className="indices" style={{ textAlign: "left" }}>
                                  {(() => {
                                    const label = details?.nifty50
                                      ? "50"
                                      : details?.nifty100
                                      ? "100"
                                      : details?.nifty200
                                      ? "200"
                                      : details?.nifty500
                                      ? "500"
                                      : details?.totalMarket
                                      ? "TM"
                                      : "";
                                    const excludedSeries = ["ETF", "BOND", "MF"];
                                    const showFev =
                                      details?.myFev &&
                                      !excludedSeries.includes(details?.series);
                                    return (
                                      label +
                                      (showFev ? `${label ? ", " : ""}Fev` : "")
                                    );
                                  })()}
                                </td>
                                <td style={{textAlign: "left", lineHeight:1.2, background: Structure.slope < 1? "#ffcdcd" : 
                                        Structure.slope >= 3 && Structure.slope <= 5
                                          ? "#fff1ac" : Structure.slope > 5? "#9ce49c"
                                          : Structure.slope >= 3 && deliveryData.structure_json.slope > Structure.slope? "#0eb90e" : "", }}                                       
                                          title={`slope: ${Structure.slope} | confidence: ${Structure.confidence} - T slope: ${deliveryData?.structure_json.slope} | T confidence: ${deliveryData?.structure_json.confidence}`}
                                
                                >{obj.setup}
                                </td>
                                <td title={`If CHOCH true | lastHigh: ${Structure.lastHigh} | lastLow: ${Structure.lastLow} | prevHigh: ${Structure.prevHigh} | prevLow: ${Structure.prevLow}`}
                                  style={{
                                      fontSize:'0.67rem',  
                                      textAlign: "left",
                                      backgroundColor: Structure.choch === true && Structure.slope > 1? '#9ce49c': ''
                                    }}
                                
                                >{`${Structure.structure}`}</td>
                                <td style={{textAlign:'left'}} title={momentum_type}>{momentum_type?.charAt(0)}</td>
                                <td style={{background: parseInt(obj.is_buy) !== 1 && isFarFromEMA20(todayLTP?.LTP, deliveryData?.EMA20)['status'] === true? "#f6fffc": parseInt(obj.is_buy) === 1 && moment(obj.buy_date).format("DD-MM-YYYY") === moment().format("DD-MM-YYYY")? "#fdd10c" : parseInt(obj.is_buy) === 1? "#fdef6f":"",}} 
                                    title={`${isFarFromEMA20(todayLTP?.LTP, deliveryData?.EMA20)['ema_distance']}% ${parseInt(obj.is_buy) === 1? ` | ${moment(obj.buy_date).format("DD-MM-YYYY")} - ${setup_buy_price}`:'' }`}>
                                  {obj.portfolio_buy_price !== null? obj.portfolio_buy_price :obj.breakout_price}</td>
                                  <td title={`${((obj.breakout_price - obj.sl_price) * 100 / obj.sl_price).toFixed(2)}% ${obj.is_triggered === "STOPLOSS"? " | " + moment(obj.triggered_date).format("DD-MM-YYYY") + " | " + days + ' days':"" }`}
                                        style={{
                                          textAlign: "right",
                                          background: obj.is_triggered === "STOPLOSS" && moment(obj.triggered_date).format("DD-MM-YYYY") === moment().format("DD-MM-YYYY")? "#ee1b1b" : obj.is_triggered === "STOPLOSS"? "#ffcbcb" : ""
                                          }}
                                  >{obj.sl_price}</td>
                                  <td title={`${((obj.target_price - obj.breakout_price) * 100 / obj.target_price).toFixed(2)}% ${obj.is_triggered === "TARGET"? " | " + moment(obj.triggered_date).format("DD-MM-YYYY")  + " | " + days + ' days' :"" }`}
                                        style={{
                                          textAlign: "right",
                                          background: obj.is_triggered === "TARGET" && moment(obj.triggered_date).format("DD-MM-YYYY") === moment().format("DD-MM-YYYY")? "#00a61c" : obj.is_triggered === "TARGET"? "#c2ffcc" : ""
                                          }}  
                                  
                                  >{obj.target_price}</td>
                                  <td title={`${obj.open_price} | ${obj.high_price} | ${obj.low_price}`}>{obj.close_price}</td>
                                  <td title={`${todayLTP?.OPEN} | ${todayLTP?.HIGH} | ${todayLTP?.LOW}`}>{todayLTP?.LTP}</td>
                                  <td
                                    style={{
                                      color:
                                        parseFloat(todayLTP?.CHANGEPER) > 0
                                          ? "#1c8b16"
                                          : "#f00",
                                    }}
                                  >
                                    {todayLTP?.CHANGEPER}
                                  </td>
                                  <td style={{
                                      color:
                                        parseFloat(tchn_per) > 0
                                          ? "#1c8b16" 
                                          : parseFloat(tchn_per) === 0
                                          ? "#999" : "#f00",
                                    }}>
                                      {/* {parseFloat(tchn_per) !== 0 && `${parseFloat(tchn_per).toFixed(2)}`} */}

                                      {(parseInt(obj.is_buy) === 1 && obj.is_triggered !=='')? `${parseFloat(tchn_per).toFixed(2)}`: (parseInt(obj.verified) === 1 && obj.is_triggered ==='')? `${parseFloat(rchn_per).toFixed(2)}`:''}
                                  </td>
                                  <td

                                    style={{
                                      textAlign: "right",
                                      background: EMA21Cross === true? "#e2ffe5":""
                                    }}
                                    title={`EMA20 > SMA20: ${deliveryData?.SMA20}`}
                                  >
                                    {deliveryData?.EMA20}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "right",
                                      background:
                                        parseFloat(deliveryData?.SMA20) >
                                        parseFloat(deliveryData?.SMA50)
                                          ? "#e2ffe5"
                                          : "#fff8f8",
                                    }}
                                    title={`SMA20: ${deliveryData?.SMA20}`}
                                  >
                                    {deliveryData?.SMA50}
                                  </td>
                                <td title={`${high52w} | ${highDate}`} 
                                    style={{background:high52wPer >= 8 && high52wPer <=40 ? "" : "#fff6f6"}}>
                                    {high52wPer.toFixed(2) + "%"}
                                  </td>
                                  <td title={`${lowDate} | ${highDate}`}>{`${low52w} | ${high52w}`}</td>
                                  <td title={`${cuurVolPer.toFixed(2)}%` }
                                      style={{background: cuurVolPer > 25 ? "#e2ffe5" : ""}}
                                  >
                                    {Number(Prev_Volume).toLocaleString("en-IN")}
                                  </td>
                                  <td title={`${obj.delivery_per} ${deliv > prevDeliv ? `| ${prevDeliv}%` : ''}`}
                                    style={{background: deliv > prevDeliv? "#e2ffe5": ""}}
                                  > 
                                    {deliv}%</td>
                                  <td style={{ textAlign: "center", padding:"0px"}}>
                                    <button
                                      type="button"
                                      className="editlist"
                                      onClick={(e) => editItemHandler(e, obj, true)}
                                      title={`${obj.notes !== null || obj.notes !== ""? obj.notes : "Edit"}`}
                                    ></button>
                                  <a
                                    title="News"
                                    className="newsicon"
                                    // href={`https://www.google.com/search?q=Analyze+NSE:${symbolName}+Check+volume+spike%2C+delivery+%25%2C+FII%2FDII+participation%2C+big+bull+accumulation%2C+promoter+changes%2C+block+deals%2C+new+orders%2C+quarterly+growth%2C+order+book%2C+institutional+buying%2C+technical+breakout+and+classify+whether+move+is+sustainable+or+speculative`}
                                    // href={`https://www.google.com/ai?q=${encodeURIComponent(`Analyze NSE:${symbolName} Check volume spike, delivery %, FII/DII participation, big bull accumulation, promoter changes, block deals, new orders, quarterly growth, order book, institutional buying, technical breakout and classify whether move is sustainable or speculative, actionable trading setup for swing`)}`}
                                    // href={`https://www.google.com/ai?q=${AIPromptForStock1(symbolName)}`}
                                    href={`https://www.google.com/search?udm=50&q=${AIPromptForStock1(symbolName)}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  ></a>
                                  </td>
                              </tr>
                            );
                          })

                       :  <tr key={`row_item_tr_110`}><td colSpan={25} style={{fontSize:"16px", fontWeight:'500', paddingTop:'10px', paddingBottom: '10px', backgroundColor:'#F0F0F0', textAlign:'center'}}>
                        No Trends Stock found for {trends}</td></tr>
                       
                    
                      }

                      
                      {/* For Breakout List */}
                      {trends === "All" && type === "Default" && searchText.length === 0 && todaysetupStatus?.Breakout?.length > 0 && (<tr key={`row_item_tr_1`}><td colSpan={25} style={{fontSize:"16px", fontWeight:'500', paddingTop:'15px', backgroundColor:'#F0F0F0'}}>Breakout [{todaysetupStatus?.Breakout?.length}]</td></tr>)}

                      {trends === "All" && type === "Default" && searchText.length === 0 && todaysetupStatus?.Breakout && todaysetupStatus?.Breakout?.map((obj, index) => {
                        // console.log(obj);
                        let symbolName = obj.symbol;
   

                        let details = symbolData?.find((s) => s.symbol === symbolName);
                        let todayLTP = todayData?.find((s) => s.TICKER === symbolName);
                        
                        let deliverylist = Object.values(deliveryDataList);
                        let deliveryData = deliverylist?.find((s) => s.symbol === symbolName);
                        let EMA21Cross = parseFloat(deliveryData?.EMA20) > parseFloat(deliveryData?.SMA20);
                        
                        
                        let high52w = details?.high52w? details?.high52w: 0;
                        let low52w = details?.low52w? details?.low52w: 0;
                        let highDate = details?.highDate? moment(details?.highDate).format("DD-MM-YY"): "";
                        let lowDate = details?.lowDate? moment(details?.lowDate).format("DD-MM-YY"): "";
                        // let Structure = JSON.parse(obj?.structure_json || '[]');
                        let Structure = deliveryData?.structure_json || [];
                        let momentum_type = deliveryData?.momentum_type;   

                        let setup_buy_price = obj.portfolio_buy_price !== null? obj.portfolio_buy_price: obj.buy_price;

                        let tchn_per = obj.is_triggered === "TARGET"?  
                            ((obj.triggered_price - setup_buy_price) * 100) / setup_buy_price :

                            obj.is_triggered === "STOPLOSS"?  
                            ((obj.triggered_price - setup_buy_price) * 100) / setup_buy_price : 0

                        let is_SLHits =  parseInt(obj.is_buy) === 1 && obj.is_triggered === "STOPLOSS"? true:false;
                        let is_TargetHits = obj.is_buy === "1" && obj.is_triggered === "TARGET"? true:false;
                        

                        const setup = obj.setup || "UNKNOWN";
                        if (!triggerStats[setup]) {
                                triggerStats[setup] = {
                                  stopLossCount: 0,
                                  targetCount: 0,
                                  total: 0,
                                  totalSL: 0,
                                  totalTarget: 0,
                                  upcomingPL: 0,
                                };
                        }

                        
                        if(is_SLHits){
                            triggerStats[setup].stopLossCount += 1;
                            triggerStats[setup].total += 1;
                            triggerCount = triggerCount + 1;
                            triggerSLCount = triggerSLCount + 1;
                            triggerStats[setup].totalSL += ((obj.triggered_price - setup_buy_price) * 100) / setup_buy_price;
                        }

                        if(is_TargetHits){
                            triggerStats[setup].targetCount += 1;
                            triggerStats[setup].total += 1;
                            triggerCount = triggerCount + 1;
                            triggerTGCount = triggerTGCount + 1;
                            triggerStats[setup].totalTarget += ((obj.triggered_price - setup_buy_price) * 100) / setup_buy_price;
                        }
                        
                        
                        let rchn_per = parseFloat(setup_buy_price) > 0 ? ((todayLTP?.LTP - setup_buy_price) * 100) / setup_buy_price : ((todayLTP?.LTP - obj.close_price) * 100) / obj.close_price;
                       
                        let high52wPer = (((high52w - todayLTP?.LTP) * 100) / high52w);

                        let Volume = parseInt((moment(todayTime).isSame(todayLTP?.DATE, 'day')) && todayMarketHoldTime() === true? todayLTP?.VOLUME: deliveryData?.stock_data?.[0]?.ttl_trd_qty);
                        let Prev_Volume = parseInt((moment(todayTime).isSame(todayLTP?.DATE, 'day')) && todayMarketHoldTime() === true? deliveryData?.stock_data?.[0]?.ttl_trd_qty:deliveryData?.stock_data?.[1]?.ttl_trd_qty);

                        
                        let cuurVolPer = ((Volume - Prev_Volume) * 100) / Prev_Volume;

                        let prevDeliv = deliveryData?.stock_data?.[1]?.delivery_per;
                        let deliv = deliveryData?.stock_data?.[0]?.delivery_per;

                        return (
                          <tr
                            className={`tr_${details?.id}`}
                            key={`row_item_b_${obj.id}`}
                            id={`row_item_b_${obj.id}`}

                            style={{background: obj.is_triggered !=='' && obj.is_triggered ==="TARGET"? "#e2f9e2": obj.is_triggered !=='' && obj.is_triggered ==="STOPLOSS"? "#ffc2c2": ""}}
                          >
                            <td style={{fontSize:'11px'}}
                                title={moment(obj.breakout_date).format('DD-MM-YY')}
                            >{obj.is_triggered !==''? moment(obj.triggered_date).format('HH:mm A'): moment(obj.buy_date).format('HH:mm A')} </td>
                          {/* <td style={{fontSize:'11px'}}>{moment(obj.breakout_date).format("DD-MM-YY")} </td> */}
                          <td 
                                className={`symbolName ${obj.in_portfolio === '1' && obj.is_triggered ===''? 'inpotfolio':''} ${obj.in_portfolio === '0' && obj.in_watchlist ==='1'? 'inwatchlist':''}`} 
                                style={{borderLeft: obj.verified === '1'? "3px solid #FF9800" : '', background: obj.today_occurred === moment().format('YYYY-MM-DD') && obj.occurance > 2? '#d3ffd5':''}}
                                title={(obj.today_occurred === moment().format('YYYY-MM-DD') && obj.occurance > 2? `[Occurance ${obj.occurance}] | ` : '')  +  (obj.in_portfolio === '1' && obj.is_triggered ===''? `Bought at: ${ moment(obj.portfolio_buy_date).format('DD-MM-YYYY')} - ${obj.portfolio_buy_price} [${obj.unit_qty}] ${obj.demat}` :  '')}
                          >
                              {symbolName}{" "}
                              {details?.hotStar === "1" ? (
                                <span className="hotStar"></span>
                              ) : null}

                              <span className="gttaction">
                                {parseInt(obj.gtt_SL) === 1 && <span className="gttSL"></span>}
                                {parseInt(obj.gtt_Target) === 1 && <span className="gttTarget"></span>}
                              </span>
                            </td>
                            <td>
                              <StockAction
                                symbol={symbolName}
                                delivery={false}
                                currentPrice={obj?.breakout_price}
                                deliveryPer={obj.delivery_per}
                                hotStar={details?.hotStar}
                                myFev={details?.myFev}
                                eventName={obj.setup}
                                slPrice={obj.sl_price}
                                gttPrice={obj.target_price}
                                rowId={`row_item_b_${obj.id}`}
                                score = {obj.score}
                              />
                            </td>
                            <td>
                              <DeliveryGraph
                                symbol={symbolName}
                                todayLTP={todayLTP}
                                date={getUniqueDates[0]}
                              />
                            </td>
                            <StockStrength
                              id={`del_${obj.id}`}
                              selectedDate={obj.delivery_date}
                              symbol={symbolName}
                              todayLTP={todayLTP}
                              details={details}
                              // predictions={obj.prediction}
                            />
                            <SectorPanchang
                              symbol={symbolName}
                              sector={details?.group_sector}
                              todayData={todayData}
                              symbolData={symbolData}
                              tag = "td"
                              align = "right"
                              durationDays = ""
                            />
                            <td title={obj.score} style={{ textAlign: "left", background: obj?.todayScore > 70 ? "#72d083": obj?.todayScore > 60 ? "#ffec9c": "" }}>
                                {obj?.todayScore}
                              </td>
                              <td className="indices" style={{ textAlign: "left" }}>
                                {(() => {
                                  const label = details?.nifty50
                                    ? "50"
                                    : details?.nifty100
                                    ? "100"
                                    : details?.nifty200
                                    ? "200"
                                    : details?.nifty500
                                    ? "500"
                                    : details?.totalMarket
                                    ? "TM"
                                    : "";
                                  const excludedSeries = ["ETF", "BOND", "MF"];
                                  const showFev =
                                    details?.myFev &&
                                    !excludedSeries.includes(details?.series);
                                  return (
                                    label +
                                    (showFev ? `${label ? ", " : ""}Fev` : "")
                                  );
                                })()}
                              </td>
                            <td style={{textAlign: "left", lineHeight:1.2, background: Structure.slope < 1? "#ffcdcd" : 
                                    Structure.slope >= 3 && Structure.slope <= 5
                                      ? "#fff1ac" : Structure.slope > 5? "#9ce49c"
                                      : Structure.slope >= 3 && deliveryData.structure_json.slope > Structure.slope? "#0eb90e" : "", }}                                       
                                      title={`slope: ${Structure.slope} | confidence: ${Structure.confidence} - T slope: ${deliveryData.structure_json.slope} | T confidence: ${deliveryData.structure_json.confidence}`}
                            
                            >{obj.setup}
                            </td>
                            <td title={`If CHOCH true | lastHigh: ${Structure.lastHigh} | lastLow: ${Structure.lastLow} | prevHigh: ${Structure.prevHigh} | prevLow: ${Structure.prevLow}`}
                              style={{
                                  fontSize:'0.67rem',  
                                  textAlign: "left",
                                  backgroundColor: Structure.choch === true && Structure.slope > 1? '#9ce49c': ''
                                }}
                            
                            >{`${Structure.structure}`}</td>
                            <td style={{textAlign:'left'}} title={momentum_type}>{momentum_type?.charAt(0)}</td>
                            <td style={{background:  parseInt(obj.is_buy) !== 1 && isFarFromEMA20(todayLTP?.LTP, deliveryData?.EMA20)['status'] === true? "#f6fffc": parseInt(obj.is_buy) === 1 && moment(obj.buy_date).format("DD-MM-YYYY") === moment().format("DD-MM-YYYY")? "#fdd10c" : parseInt(obj.is_buy) === 1? "#fdef6f":"",}} 
                                title={`${isFarFromEMA20(todayLTP?.LTP, deliveryData?.EMA20)['ema_distance']}% ${parseInt(obj.is_buy) === 1? ` | ${moment(obj.buy_date).format("DD-MM-YYYY")} - ${setup_buy_price}`:'' }`}>
                              {obj.breakout_price}</td>
                              <td 
                              title={`${((obj.breakout_price - obj.sl_price) * 100 / obj.sl_price).toFixed(2)}% ${obj.is_triggered === "STOPLOSS"? " | " + moment(obj.triggered_date).format("DD-MM-YYYY") :"" }`}
                                    style={{
                                      textAlign: "right",
                                      background: obj.is_triggered === "STOPLOSS" && moment(obj.triggered_date).format("DD-MM-YYYY") === moment().format("DD-MM-YYYY")? "#ee1b1b" : obj.is_triggered === "STOPLOSS"? "#ffcbcb" : ""
                                      }}
                              >{obj.sl_price}</td>
                              <td 
                              title={`${((obj.target_price - obj.breakout_price) * 100 / obj.target_price).toFixed(2)}% ${obj.is_triggered === "TARGET"? " | " + moment(obj.triggered_date).format("DD-MM-YYYY") :"" }`}
                                    style={{
                                      textAlign: "right",
                                      background: obj.is_triggered === "TARGET" && moment(obj.triggered_date).format("DD-MM-YYYY") === moment().format("DD-MM-YYYY")? "#00a61c" : obj.is_triggered === "TARGET"? "#c2ffcc" : ""
                                      }}  
                              
                              >{obj.target_price}</td>
                              <td title={`${obj.open_price} | ${obj.high_price} | ${obj.low_price}`}>{obj.close_price}</td>
                              <td title={`${todayLTP?.OPEN} | ${todayLTP?.HIGH} | ${todayLTP?.LOW}`}>{todayLTP?.LTP}</td>
                              <td
                                style={{
                                  color:
                                    parseFloat(todayLTP?.CHANGEPER) > 0
                                      ? "#1c8b16"
                                      : "#f00",
                                }}
                              >
                                {todayLTP?.CHANGEPER}
                              </td>
                              <td style={{
                                  color:
                                    parseFloat(tchn_per) > 0
                                      ? "#1c8b16" 
                                      : parseFloat(tchn_per) === 0
                                      ? "#999" : "#f00",
                                }}>
                                  {/* {parseFloat(tchn_per) !== 0 && `${parseFloat(tchn_per).toFixed(2)}`} */}

                                  {(parseInt(obj.is_buy) === 1 && obj.is_triggered !=='')? `${parseFloat(tchn_per).toFixed(2)}`: (parseInt(obj.is_buy) === 1 && obj.is_triggered ==='')? `${parseFloat(rchn_per).toFixed(2)}`:''}
                              </td>
                              <td

                                style={{
                                  textAlign: "right",
                                  background: EMA21Cross === true? "#e2ffe5":""
                                }}
                                title={`EMA20 > SMA20: ${deliveryData?.SMA20}`}
                              >
                                {deliveryData?.EMA20}
                              </td>
                              <td
                                style={{
                                  textAlign: "right",
                                  background:
                                    parseFloat(deliveryData?.SMA20) >
                                    parseFloat(deliveryData?.SMA50)
                                      ? "#e2ffe5"
                                      : "#fff8f8",
                                }}
                                title={`SMA20: ${deliveryData?.SMA20}`}
                              >
                                {deliveryData?.SMA50}
                              </td>
                            <td title={`${high52w} | ${highDate}`} 
                                style={{background:high52wPer >= 8 && high52wPer <=40 ? "" : "#fff6f6"}}>
                                {high52wPer.toFixed(2) + "%"}
                              </td>
                              <td title={`${lowDate} | ${highDate}`}>{`${low52w} | ${high52w}`}</td>
                              <td title={`${cuurVolPer.toFixed(2)}%` }
                                  style={{background: cuurVolPer > 25 ? "#e2ffe5" : ""}}
                              >
                                {Number(Prev_Volume).toLocaleString("en-IN")}
                              </td>
                              <td title={deliv > prevDeliv? `${prevDeliv}%`:''}
                                style={{background: deliv > prevDeliv? "#e2ffe5": ""}}
                              > 
                                {deliv}%</td>
                              <td style={{ textAlign: "center", padding:"0px"}}>
                                <button
                                  type="button"
                                  className="editlist"
                                  onClick={(e) => editItemHandler(e, obj, true)}
                                  title={`${obj.notes !== null || obj.notes !== ""? obj.notes : "Edit"}`}
                                ></button>
                              <a
                                title="News"
                                className="newsicon"
                                // href={`https://www.google.com/search?q=${symbolName}+stock+fundamental+analysis+latest+news+broker+report+target+price+intrinsic+value+prospects`}
                                // href={`https://www.google.com/search?q=NSE:${symbolName}+why+stock+is+rising+volume+spike+buy+or+sell`}
                                // href={`https://www.google.com/search?q=${symbolName}+NSE+EQ+stock+analysis+analyst+recommendation+future+growth+outlook`}
                                href={`https://www.google.com/ai?q=${AIPromptForStock1(symbolName)}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              ></a>
                              </td>
                          </tr>
                        );
                      })}

                      {/* For Near to Breakout List */}
                      {trends === "All" && type === "Default" && searchText.length === 0 && todaysetupStatus?.NearToBreakout?.length > 0 && (<tr key={`row_item_tr_2`}><td colSpan={25} style={{fontSize:"16px", fontWeight:'500', paddingTop:'15px', backgroundColor:'#F0F0F0'}}>Near to Breakout [{todaysetupStatus?.NearToBreakout?.length}]</td></tr>)}

                      {trends === "All" && type === "Default" && searchText.length === 0 && todaysetupStatus?.NearToBreakout && todaysetupStatus?.NearToBreakout?.map((obj, index) => {
                        // console.log(obj);
                        let symbolName = obj.symbol;
   

                        let details = symbolData?.find((s) => s.symbol === symbolName);
                        let todayLTP = todayData?.find((s) => s.TICKER === symbolName);
                        
                        let deliverylist = Object.values(deliveryDataList);
                        let deliveryData = deliverylist?.find((s) => s.symbol === symbolName);
                        let EMA21Cross = parseFloat(deliveryData?.EMA20) > parseFloat(deliveryData?.SMA20);
                        
                        
                        let high52w = details?.high52w? details?.high52w: 0;
                        let low52w = details?.low52w? details?.low52w: 0;
                        let highDate = details?.highDate? moment(details?.highDate).format("DD-MM-YY"): "";
                        let lowDate = details?.lowDate? moment(details?.lowDate).format("DD-MM-YY"): "";
                        // let Structure = JSON.parse(obj?.structure_json || '[]');
                        let Structure = deliveryData?.structure_json || [];
                        let momentum_type = deliveryData?.momentum_type;   

                        let setup_buy_price = obj.portfolio_buy_price !== null? obj.portfolio_buy_price: obj.buy_price;

                        let tchn_per = obj.is_triggered === "TARGET"?  
                            ((obj.triggered_price - setup_buy_price) * 100) / setup_buy_price :

                            obj.is_triggered === "STOPLOSS"?  
                            ((obj.triggered_price - setup_buy_price) * 100) / setup_buy_price : 0

                        let is_SLHits =  parseInt(obj.is_buy) === 1 && obj.is_triggered === "STOPLOSS"? true:false;
                        let is_TargetHits = obj.is_buy === "1" && obj.is_triggered === "TARGET"? true:false;
                      

                        let rchn_per = parseFloat(setup_buy_price) > 0 ? ((todayLTP?.LTP - setup_buy_price) * 100) / setup_buy_price : ((todayLTP?.LTP - obj.close_price) * 100) / obj.close_price;
                       
                        let high52wPer = (((high52w - todayLTP?.LTP) * 100) / high52w);

                        let Volume = parseInt((moment(todayTime).isSame(todayLTP?.DATE, 'day')) && todayMarketHoldTime() === true? todayLTP?.VOLUME: deliveryData?.stock_data?.[0]?.ttl_trd_qty);
                        let Prev_Volume = parseInt((moment(todayTime).isSame(todayLTP?.DATE, 'day')) && todayMarketHoldTime() === true? deliveryData?.stock_data?.[0]?.ttl_trd_qty:deliveryData?.stock_data?.[1]?.ttl_trd_qty);

                        
                        let cuurVolPer = ((Volume - Prev_Volume) * 100) / Prev_Volume;

                        let prevDeliv = deliveryData?.stock_data?.[1]?.delivery_per;
                        let deliv = deliveryData?.stock_data?.[0]?.delivery_per;

                        return (
                          <tr
                            className={`tr_${details?.id}`}
                            key={`row_item_c_${obj.id}`}
                            id={`row_item_c_${obj.id}`}
                          >
                          <td style={{fontSize:'11px'}}>{moment(obj.breakout_date).format("DD-MM-YY")} </td>
                          <td 
                                className={`symbolName ${obj.in_portfolio === '1' && obj.is_triggered ===''? 'inpotfolio':''} ${obj.in_portfolio === '0' && obj.in_watchlist ==='1'? 'inwatchlist':''}`} 
                                style={{borderLeft: obj.verified === '1'? "3px solid #FF9800" : '', background: obj.today_occurred === moment().format('YYYY-MM-DD') && obj.occurance > 2? '#d3ffd5':''}}
                                title={(obj.today_occurred === moment().format('YYYY-MM-DD') && obj.occurance > 2? `[Occurance ${obj.occurance}] | ` : '')  +  (obj.in_portfolio === '1' && obj.is_triggered ===''? `Bought at: ${ moment(obj.portfolio_buy_date).format('DD-MM-YYYY')} - ${obj.portfolio_buy_price} [${obj.unit_qty}] ${obj.demat}` :  '')}
                          >
                              {symbolName}{" "}
                              {details?.hotStar === "1" ? (
                                <span className="hotStar"></span>
                              ) : null}

                                     <span className="gttaction">
                                      {parseInt(obj.gtt_SL) === 1 && <span className="gttSL"></span>}
                                      {parseInt(obj.gtt_Target) === 1 && <span className="gttTarget"></span>}
                                    </span>
                            </td>
                            <td>
                              <StockAction
                                symbol={symbolName}
                                delivery={false}
                                currentPrice={obj?.breakout_price}
                                deliveryPer={obj.delivery_per}
                                hotStar={details?.hotStar}
                                myFev={details?.myFev}
                                eventName={obj.setup}
                                slPrice={obj.sl_price}
                                gttPrice={obj.target_price}
                                rowId={`row_item_c_${obj.id}`}
                                score = {obj.score}
                              />
                            </td>
                            <td>
                              <DeliveryGraph
                                symbol={symbolName}
                                todayLTP={todayLTP}
                                date={getUniqueDates[0]}
                              />
                            </td>
                            <StockStrength
                              id={`del_${obj.id}`}
                              selectedDate={obj.delivery_date}
                              symbol={symbolName}
                              todayLTP={todayLTP}
                              details={details}
                              // predictions={obj.prediction}
                            />
                            <SectorPanchang
                              symbol={symbolName}
                              sector={details?.group_sector}
                              todayData={todayData}
                              symbolData={symbolData}
                              tag = "td"
                              align = "right"
                              durationDays = ""
                            />
                            <td title={obj.score} style={{ textAlign: "left", background: obj?.todayScore > 70 ? "#72d083": obj?.todayScore > 60 ? "#ffec9c": "" }}>
                                {obj?.todayScore}
                              </td>
                              <td className="indices" style={{ textAlign: "left" }}>
                                {(() => {
                                  const label = details?.nifty50
                                    ? "50"
                                    : details?.nifty100
                                    ? "100"
                                    : details?.nifty200
                                    ? "200"
                                    : details?.nifty500
                                    ? "500"
                                    : details?.totalMarket
                                    ? "TM"
                                    : "";
                                  const excludedSeries = ["ETF", "BOND", "MF"];
                                  const showFev =
                                    details?.myFev &&
                                    !excludedSeries.includes(details?.series);
                                  return (
                                    label +
                                    (showFev ? `${label ? ", " : ""}Fev` : "")
                                  );
                                })()}
                              </td>
                            <td style={{textAlign: "left", lineHeight:1.2, background: Structure.slope < 1? "#ffcdcd" : 
                                    Structure.slope >= 3 && Structure.slope <= 5
                                      ? "#fff1ac" : Structure.slope > 5? "#9ce49c"
                                      : Structure.slope >= 3 && deliveryData.structure_json.slope > Structure.slope? "#0eb90e" : "", }}                                       
                                      title={`slope: ${Structure.slope} | confidence: ${Structure.confidence} - T slope: ${deliveryData.structure_json.slope} | T confidence: ${deliveryData.structure_json.confidence}`}
                            
                            >{obj.setup}
                            </td>
                            <td title={`If CHOCH true | lastHigh: ${Structure.lastHigh} | lastLow: ${Structure.lastLow} | prevHigh: ${Structure.prevHigh} | prevLow: ${Structure.prevLow}`}
                              style={{
                                  fontSize:'0.67rem',  
                                  textAlign: "left",
                                  backgroundColor: Structure.choch === true && Structure.slope > 1? '#9ce49c': ''
                                }}
                            
                            >{`${Structure.structure}`}</td>
                            <td style={{textAlign:'left'}} title={momentum_type}>{momentum_type?.charAt(0)}</td>
                            <td style={{background:  parseInt(obj.is_buy) !== 1 && isFarFromEMA20(todayLTP?.LTP, deliveryData?.EMA20)['status'] === true? "#f6fffc": parseInt(obj.is_buy) === 1 && moment(obj.buy_date).format("DD-MM-YYYY") === moment().format("DD-MM-YYYY")? "#fdd10c" : parseInt(obj.is_buy) === 1? "#fdef6f":"",}} 
                                title={`${isFarFromEMA20(todayLTP?.LTP, deliveryData?.EMA20)['ema_distance']}% ${parseInt(obj.is_buy) === 1? ` | ${moment(obj.buy_date).format("DD-MM-YYYY")} - ${setup_buy_price}`:'' }`}>
                              {obj.breakout_price}</td>
                              <td title={`${obj.is_triggered === "STOPLOSS"? moment(obj.triggered_date).format("DD-MM-YYYY") :"" }`}
                                    style={{
                                      textAlign: "right",
                                      background: obj.is_triggered === "STOPLOSS" && moment(obj.triggered_date).format("DD-MM-YYYY") === moment().format("DD-MM-YYYY")? "#ee1b1b" : obj.is_triggered === "STOPLOSS"? "#ffcbcb" : ""
                                      }}
                              >{obj.sl_price}</td>
                              <td title={`${obj.is_triggered === "TARGET"? moment(obj.triggered_date).format("DD-MM-YYYY") :"" }`}
                                    style={{
                                      textAlign: "right",
                                      background: obj.is_triggered === "TARGET" && moment(obj.triggered_date).format("DD-MM-YYYY") === moment().format("DD-MM-YYYY")? "#00a61c" : obj.is_triggered === "TARGET"? "#c2ffcc" : ""
                                      }}  
                              
                              >{obj.target_price}</td>
                              <td title={`${obj.open_price} | ${obj.high_price} | ${obj.low_price}`}>{obj.close_price}</td>
                              <td title={`${todayLTP?.OPEN} | ${todayLTP?.HIGH} | ${todayLTP?.LOW}`}>{todayLTP?.LTP}</td>
                              <td
                                style={{
                                  color:
                                    parseFloat(todayLTP?.CHANGEPER) > 0
                                      ? "#1c8b16"
                                      : "#f00",
                                }}
                              >
                                {todayLTP?.CHANGEPER}
                              </td>
                              <td style={{
                                  color:
                                    parseFloat(tchn_per) > 0
                                      ? "#1c8b16" 
                                      : parseFloat(tchn_per) === 0
                                      ? "#999" : "#f00",
                                }}>
                                  {/* {parseFloat(tchn_per) !== 0 && `${parseFloat(tchn_per).toFixed(2)}`} */}

                                  {(parseInt(obj.is_buy) === 1 && obj.is_triggered !=='')? `${parseFloat(tchn_per).toFixed(2)}`: (parseInt(obj.is_buy) === 1 && obj.is_triggered ==='')? `${parseFloat(rchn_per).toFixed(2)}`:''}
                              </td>
                              <td

                                style={{
                                  textAlign: "right",
                                  background: EMA21Cross === true? "#e2ffe5":""
                                }}
                                title={`EMA20 > SMA20: ${deliveryData?.SMA20}`}
                              >
                                {deliveryData?.EMA20}
                              </td>
                              <td
                                style={{
                                  textAlign: "right",
                                  background:
                                    parseFloat(deliveryData?.SMA20) >
                                    parseFloat(deliveryData?.SMA50)
                                      ? "#e2ffe5"
                                      : "#fff8f8",
                                }}
                                title={`SMA20: ${deliveryData?.SMA20}`}
                              >
                                {deliveryData?.SMA50}
                              </td>
                            <td title={`${high52w} | ${highDate}`} 
                                style={{background:high52wPer >= 8 && high52wPer <=40 ? "" : "#fff6f6"}}>
                                {high52wPer.toFixed(2) + "%"}
                              </td>
                              <td title={`${lowDate} | ${highDate}`}>{`${low52w} | ${high52w}`}</td>
                              <td title={`${cuurVolPer.toFixed(2)}%` }
                                  style={{background: cuurVolPer > 25 ? "#e2ffe5" : ""}}
                              >
                                {Number(Prev_Volume).toLocaleString("en-IN")}
                              </td>
                              <td title={deliv > prevDeliv? `${prevDeliv}%`:''}
                                style={{background: deliv > prevDeliv? "#e2ffe5": ""}}
                              > 
                                {deliv}%</td>
                              <td style={{ textAlign: "center", padding:"0px"}}>
                                <button
                                  type="button"
                                  className="editlist"
                                  onClick={(e) => editItemHandler(e, obj, true)}
                                  title={`${obj.notes !== null || obj.notes !== ""? obj.notes : "Edit"}`}
                                ></button>
                              <a
                                title="News"
                                className="newsicon"
                                // href={`https://www.google.com/search?q=${symbolName}+stock+fundamental+analysis+latest+news+broker+report+target+price+intrinsic+value+prospects`}
                                //href={`https://www.google.com/search?q=NSE:${symbolName}+why+stock+is+rising+volume+spike+buy+or+sell`}
                                // href={`https://www.google.com/search?q=${symbolName}+NSE+EQ+stock+analysis+analyst+recommendation+future+growth+outlook`}
                                href={`https://www.google.com/ai?q=${AIPromptForStock1(symbolName)}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              ></a>
                              </td>
                          </tr>
                        );
                      })} 


                      {/* For Today Momntum List */}
                      {trends === "All" && type === "Default" && searchText.length === 0 && todaysetupStatus?.TodaysMomentum?.length > 0 && (<tr key={`row_item_tr_3`}><td colSpan={25} style={{fontSize:"16px", fontWeight:'500', paddingTop:'15px', backgroundColor:'#F0F0F0'}}>Today Momentum [{todaysetupStatus?.TodaysMomentum?.length}]</td></tr>)}

                      {trends === "All" && type === "Default" && searchText.length === 0 && todaysetupStatus?.TodaysMomentum && todaysetupStatus?.TodaysMomentum?.map((obj, index) => {
                        // console.log(obj);
                        let symbolName = obj.symbol;
   

                        let details = symbolData?.find((s) => s.symbol === symbolName);
                        let todayLTP = todayData?.find((s) => s.TICKER === symbolName);
                        
                        let deliverylist = Object.values(deliveryDataList);
                        let deliveryData = deliverylist?.find((s) => s.symbol === symbolName);
                        let EMA21Cross = parseFloat(deliveryData?.EMA20) > parseFloat(deliveryData?.SMA20);
                        
                        
                        let high52w = details?.high52w? details?.high52w: 0;
                        let low52w = details?.low52w? details?.low52w: 0;
                        let highDate = details?.highDate? moment(details?.highDate).format("DD-MM-YY"): "";
                        let lowDate = details?.lowDate? moment(details?.lowDate).format("DD-MM-YY"): "";
                        // let Structure = JSON.parse(obj?.structure_json || '[]');
                        let Structure = deliveryData?.structure_json || [];
                        let momentum_type = deliveryData?.momentum_type;   

                        let setup_buy_price = obj.portfolio_buy_price !== null? obj.portfolio_buy_price: obj.buy_price;

                        let tchn_per =   ((todayLTP?.LTP - obj.momentum_price) * 100) / obj.momentum_price;
                        
                        let rchn_per = parseFloat(setup_buy_price) > 0 ? ((todayLTP?.LTP - setup_buy_price) * 100) / setup_buy_price : ((todayLTP?.LTP - obj.close_price) * 100) / obj.close_price;
                       
                        let high52wPer = (((high52w - todayLTP?.LTP) * 100) / high52w);

                        let Volume = parseInt((moment(todayTime).isSame(todayLTP?.DATE, 'day')) && todayMarketHoldTime() === true? todayLTP?.VOLUME: deliveryData?.stock_data?.[0]?.ttl_trd_qty);
                        let Prev_Volume = parseInt((moment(todayTime).isSame(todayLTP?.DATE, 'day')) && todayMarketHoldTime() === true? deliveryData?.stock_data?.[0]?.ttl_trd_qty:deliveryData?.stock_data?.[1]?.ttl_trd_qty);

                        
                        let cuurVolPer = ((Volume - Prev_Volume) * 100) / Prev_Volume;

                        let prevDeliv = deliveryData?.stock_data?.[1]?.delivery_per;
                        let deliv = deliveryData?.stock_data?.[0]?.delivery_per;

                        return (
                          <tr
                            className={`tr_${details?.id}`}
                            key={`row_item_b_${obj.id}`}
                            id={`row_item_b_${obj.id}`}
                          >
                          <td style={{fontSize:'11px'}}
                            title={moment(obj.breakout_date).format('DD-MM-YY')}
                          >{moment(obj.today_momentum).format("HH:mm A")} </td>
                          <td 
                              className={`symbolName ${obj.in_portfolio === '1' && obj.is_triggered ===''? 'inpotfolio':''} ${obj.in_portfolio === '0' && obj.in_watchlist ==='1'? 'inwatchlist':''}`} 
                              style={{borderLeft: obj.verified === '1'? "3px solid #FF9800" : '', background: obj.today_occurred === moment().format('YYYY-MM-DD') && obj.occurance > 2? '#d3ffd5':''}}
                              title={(obj.today_occurred === moment().format('YYYY-MM-DD') && obj.occurance > 2? `[Occurance ${obj.occurance}] | ` : '')  +  (obj.in_portfolio === '1' && obj.is_triggered ===''? `Bought at: ${ moment(obj.portfolio_buy_date).format('DD-MM-YYYY')} - ${obj.portfolio_buy_price} [${obj.unit_qty}] ${obj.demat}` :  '')}
                          >
                              {symbolName}{" "}
                              {details?.hotStar === "1" ? (
                                <span className="hotStar"></span>
                              ) : null}

                              <span className="gttaction">
                                {parseInt(obj.gtt_SL) === 1 && <span className="gttSL"></span>}
                                {parseInt(obj.gtt_Target) === 1 && <span className="gttTarget"></span>}
                              </span>
                            </td>
                            <td>
                              <StockAction
                                symbol={symbolName}
                                delivery={false}
                                currentPrice={obj?.breakout_price}
                                deliveryPer={obj.delivery_per}
                                hotStar={details?.hotStar}
                                myFev={details?.myFev}
                                eventName={obj.setup}
                                slPrice={obj.sl_price}
                                gttPrice={obj.target_price}
                                rowId={`row_item_b_${obj.id}`}
                                score = {obj.score}
                              />
                            </td>
                            <td>
                              <DeliveryGraph
                                symbol={symbolName}
                                todayLTP={todayLTP}
                                date={getUniqueDates[0]}
                              />
                            </td>
                            <StockStrength
                              id={`del_${obj.id}`}
                              selectedDate={obj.delivery_date}
                              symbol={symbolName}
                              todayLTP={todayLTP}
                              details={details}
                            />
                            <SectorPanchang
                              symbol={symbolName}
                              sector={details?.group_sector}
                              todayData={todayData}
                              symbolData={symbolData}
                              tag = "td"
                              align = "right"
                              durationDays = ""
                            />
                            <td title={obj.score} style={{ textAlign: "left", background: obj?.todayScore > 70 ? "#72d083": obj?.todayScore > 60 ? "#ffec9c": "" }}>
                                {obj?.todayScore}
                              </td>
                              <td className="indices" style={{ textAlign: "left" }}>
                                {(() => {
                                  const label = details?.nifty50
                                    ? "50"
                                    : details?.nifty100
                                    ? "100"
                                    : details?.nifty200
                                    ? "200"
                                    : details?.nifty500
                                    ? "500"
                                    : details?.totalMarket
                                    ? "TM"
                                    : "";
                                  const excludedSeries = ["ETF", "BOND", "MF"];
                                  const showFev =
                                    details?.myFev &&
                                    !excludedSeries.includes(details?.series);
                                  return (
                                    label +
                                    (showFev ? `${label ? ", " : ""}Fev` : "")
                                  );
                                })()}
                              </td>
                            <td style={{textAlign: "left", lineHeight:1.2, background: Structure.slope < 1? "#ffcdcd" : 
                                    Structure.slope >= 3 && Structure.slope <= 5
                                      ? "#fff1ac" : Structure.slope > 5? "#9ce49c"
                                      : Structure.slope >= 3 && deliveryData.structure_json.slope > Structure.slope? "#0eb90e" : "", }}                                       
                                      title={`slope: ${Structure.slope} | confidence: ${Structure.confidence} - T slope: ${deliveryData.structure_json.slope} | T confidence: ${deliveryData.structure_json.confidence}`}
                            
                            >{obj.setup}
                            </td>
                            <td title={`If CHOCH true | lastHigh: ${Structure.lastHigh} | lastLow: ${Structure.lastLow} | prevHigh: ${Structure.prevHigh} | prevLow: ${Structure.prevLow}`}
                              style={{
                                  fontSize:'0.67rem',  
                                  textAlign: "left",
                                  backgroundColor: Structure.choch === true && Structure.slope > 1? '#9ce49c': ''
                                }}
                            
                            >{`${Structure.structure}`}</td>
                            <td style={{textAlign:'left'}} title={momentum_type}>{momentum_type?.charAt(0)}</td>
                            <td style={{background:  parseInt(obj.is_buy) !== 1 &&  isFarFromEMA20(todayLTP?.LTP, deliveryData?.EMA20)['status'] === true? "#f6fffc": parseInt(obj.is_buy) === 1 && moment(obj.buy_date).format("DD-MM-YYYY") === moment().format("DD-MM-YYYY")? "#fdd10c" : parseInt(obj.is_buy) === 1? "#fdef6f":"",}} 
                                title={`${isFarFromEMA20(todayLTP?.LTP, deliveryData?.EMA20)['ema_distance']}% ${parseInt(obj.is_buy) === 1? ` | ${moment(obj.buy_date).format("DD-MM-YYYY")} - ${setup_buy_price}`:'' }`}>
                              {obj.breakout_price}</td>
                              <td title={`${obj.is_triggered === "STOPLOSS"? moment(obj.triggered_date).format("DD-MM-YYYY") :"" }`}
                                    style={{
                                      textAlign: "right",
                                      background: obj.is_triggered === "STOPLOSS" && moment(obj.triggered_date).format("DD-MM-YYYY") === moment().format("DD-MM-YYYY")? "#ee1b1b" : obj.is_triggered === "STOPLOSS"? "#ffcbcb" : ""
                                      }}
                              >{obj.sl_price}</td>
                              <td title={`${obj.is_triggered === "TARGET"? moment(obj.triggered_date).format("DD-MM-YYYY") :"" }`}
                                    style={{
                                      textAlign: "right",
                                      background: obj.is_triggered === "TARGET" && moment(obj.triggered_date).format("DD-MM-YYYY") === moment().format("DD-MM-YYYY")? "#00a61c" : obj.is_triggered === "TARGET"? "#c2ffcc" : ""
                                      }}  
                              
                              >{obj.target_price}</td>
                              <td title={`${obj.open_price} | ${obj.high_price} | ${obj.low_price}`}>{obj.close_price}</td>
                              <td title={`${todayLTP?.OPEN} | ${todayLTP?.HIGH} | ${todayLTP?.LOW}`}>{todayLTP?.LTP}</td>
                              <td
                                style={{
                                  color:
                                    parseFloat(todayLTP?.CHANGEPER) > 0
                                      ? "#1c8b16"
                                      : "#f00",
                                }}
                              >
                                {todayLTP?.CHANGEPER}
                              </td>
                              <td style={{
                                  color:
                                    parseFloat(tchn_per) > 0
                                      ? "#1c8b16" 
                                      : parseFloat(tchn_per) === 0
                                      ? "#999" : "#f00",
                                }}>
                                  {parseFloat(tchn_per) !== 0 && `${parseFloat(tchn_per).toFixed(2)}`}
                                  
                              </td>
                              <td
                                style={{
                                  textAlign: "right",
                                  background: EMA21Cross === true? "#e2ffe5":""
                                }}
                                title={`EMA20 > SMA20: ${deliveryData?.SMA20}`}
                              >
                                {deliveryData?.EMA20}
                              </td>
                              <td
                                style={{
                                  textAlign: "right",
                                  background:
                                    parseFloat(deliveryData?.SMA20) >
                                    parseFloat(deliveryData?.SMA50)
                                      ? "#e2ffe5"
                                      : "#fff8f8",
                                }}
                                title={`SMA20: ${deliveryData?.SMA20}`}
                              >
                                {deliveryData?.SMA50}
                              </td>
                            <td title={`${high52w} | ${highDate}`} 
                                style={{background:high52wPer >= 8 && high52wPer <=40 ? "" : "#fff6f6"}}>
                                {high52wPer.toFixed(2) + "%"}
                              </td>
                              <td title={`${lowDate} | ${highDate}`}>{`${low52w} | ${high52w}`}</td>
                              <td title={`${cuurVolPer.toFixed(2)}%` }
                                  style={{background: cuurVolPer > 25 ? "#e2ffe5" : ""}}
                              >
                                {Number(Prev_Volume).toLocaleString("en-IN")}
                              </td>
                              <td title={deliv > prevDeliv? `${prevDeliv}%`:''}
                                style={{background: deliv > prevDeliv? "#e2ffe5": ""}}
                              > 
                                {deliv}%</td>
                              <td style={{ textAlign: "center", padding:"0px"}}>
                                <button
                                  type="button"
                                  className="editlist"
                                  onClick={(e) => editItemHandler(e, obj, true)}
                                  title={`${obj.notes !== null || obj.notes !== ""? obj.notes : "Edit"}`}
                                ></button>
                              <a
                                title="News"
                                className="newsicon"
                                // href={`https://www.google.com/search?q=${symbolName}+stock+fundamental+analysis+latest+news+broker+report+target+price+intrinsic+value+prospects`}
                                // href={`https://www.google.com/search?q=NSE:${symbolName}+why+stock+is+rising+volume+spike+buy+or+sell`}
                                // href={`https://www.google.com/search?q=${symbolName}+NSE+EQ+stock+analysis+analyst+recommendation+future+growth+outlook`}
                                href={`https://www.google.com/ai?q=${AIPromptForStock1(symbolName)}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              ></a>
                              </td>
                          </tr>
                        );
                      })}          


                      {/* For Today Intraday setup List */}
                      {intradayData?.length > 0 && (<tr key={`row_item_tr_4`}><td colSpan={25} style={{fontSize:"16px", fontWeight:'500', paddingTop:'15px', backgroundColor:'#F0F0F0'}}>Intraday Stock [{intradayData?.length}]</td></tr>)}          
                      {intradayData && intradayData.map((obj, index) => {
                        
                        let symbolName = obj.symbol;
   

                        let details = symbolData?.find((s) => s.symbol === symbolName);
                        let todayLTP = todayData?.find((s) => s.TICKER === symbolName);

                        
                        
                        let deliverylist = Object.values(deliveryDataList);
                        let deliveryData = deliverylist?.find((s) => s.symbol === symbolName);
                        let EMA21Cross = parseFloat(deliveryData?.EMA20) > parseFloat(deliveryData?.SMA20);
                        
                        let high52w = details?.high52w? details?.high52w: 0;
                        let low52w = details?.low52w? details?.low52w: 0;
                        let highDate = details?.highDate? moment(details?.highDate).format("DD-MM-YY"): "";
                        let lowDate = details?.lowDate? moment(details?.lowDate).format("DD-MM-YY"): "";
                        // let Structure = JSON.parse(obj?.structure_json || '[]');
                        let Structure = deliveryData?.structure_json || JSON.parse(obj?.structure_json || '[]');
                        let momentum_type = deliveryData?.momentum_type;   
                                         
                        let setup_buy_price = obj.portfolio_buy_price !== null? obj.portfolio_buy_price: obj.buy_price;

                        let lastStockData = obj;                        

                        let tchn_per =  ((todayLTP?.LTP - lastStockData?.breakout_price) * 100) / lastStockData?.breakout_price;                        
                        
                       
                        let high52wPer = (((high52w - todayLTP?.LTP) * 100) / high52w);

                        let Volume = parseInt((moment(todayTime).isSame(todayLTP?.DATE, 'day')) && todayMarketHoldTime() === true? todayLTP?.VOLUME: deliveryData?.ttl_trd_qty);
                        let Prev_Volume = parseInt((moment(todayTime).isSame(todayLTP?.DATE, 'day')) && todayMarketHoldTime() === true? deliveryData?.stock_data?.[0]?.ttl_trd_qty:deliveryData?.stock_data?.[1]?.ttl_trd_qty);

                        
                        let cuurVolPer = ((Volume - Prev_Volume) * 100) / Prev_Volume;

                        let prevDeliv = obj.prev_delivery_per; //deliveryData?.stock_data?.[1]?.delivery_per;
                        let deliv =  obj.delivery_per; //deliveryData?.stock_data?.[0]?.delivery_per;

                        

                       return (
                          <tr
                            // className={`tr_${details?.id}`}
                            key={`row_item_int_${index}`}
                            id={`row_item_int_${index}`}
                          >

                          <td style={{fontSize:'11px'}}>{obj.breakout_datetime}</td>
                           <td className="symbolName">
                              {symbolName}
                              <span className="gttaction">
                                {parseInt(obj.gtt_SL) === 1 && <span className="gttSL"></span>}
                                {parseInt(obj.gtt_Target) === 1 && <span className="gttTarget"></span>}
                              </span>
                            </td>
                           <td>
                              <StockAction
                                symbol={symbolName}
                                delivery={false}
                                currentPrice={(lastStockData?.close_price * 0.975).toFixed(2)}
                                deliveryPer={obj.delivery_per}
                                hotStar={obj?.hotStar}
                                myFev={obj?.myFev}
                                eventName={obj?.setup}
                                slPrice={lastStockData?.low_price}
                                gttPrice={(lastStockData?.close_price * 1.025).toFixed(2)}
                                rowId={`row_item_int_${index}`}
                                score = {obj.score}
                              />
                            </td>
                             <td>
                              <DeliveryGraph
                                symbol={symbolName}
                                todayLTP={todayLTP}
                                date={getUniqueDates[0]}
                              />
                            </td>
                            <StockStrength
                              id={`intra_${index}`}
                              selectedDate={obj.delivery_date}
                              symbol={symbolName}
                              todayLTP={todayLTP}
                              details={details}
                            />
                            <SectorPanchang
                              symbol={symbolName}
                              sector={details?.group_sector}
                              todayData={todayData}
                              symbolData={symbolData}
                              tag = "td"
                              align = "right"
                              durationDays = ""
                            />
                            <td style={{ textAlign: "left", background: obj.score > 70 ? "#72d083": obj.score > 60 ? "#ffec9c": "" }}>
                                {obj.score}
                              </td>
                             <td className="indices" style={{ textAlign: "left" }}>
                                {(() => {
                                  const label = details?.nifty50
                                    ? "50"
                                    : details?.nifty100
                                    ? "100"
                                    : details?.nifty200
                                    ? "200"
                                    : details?.nifty500
                                    ? "500"
                                    : details?.totalMarket
                                    ? "TM"
                                    : "";
                                  const excludedSeries = ["ETF", "BOND", "MF"];
                                  const showFev =
                                    details?.myFev &&
                                    !excludedSeries.includes(details?.series);
                                  return (
                                    label +
                                    (showFev ? `${label ? ", " : ""}Fev` : "")
                                  );
                                })()}
                              </td> 
                            <td style={{textAlign: "left", lineHeight:1.2, background: Structure.slope < 1? "#ffcdcd" : 
                                    Structure.slope >= 3 && Structure.slope <= 5
                                      ? "#fff1ac" : Structure.slope > 5? "#9ce49c"
                                      : Structure.slope >= 3 && deliveryData.structure_json.slope > Structure.slope? "#0eb90e" : "", }}                                       
                                      title={`slope: ${Structure.slope} | confidence: ${Structure.confidence} - T slope: ${deliveryData?.structure_json.slope} | T confidence: ${deliveryData?.structure_json.confidence}`}
                            
                            >{obj.setup}
                            </td>
                            <td title={`If CHOCH true | lastHigh: ${Structure.lastHigh} | lastLow: ${Structure.lastLow} | prevHigh: ${Structure.prevHigh} | prevLow: ${Structure.prevLow}`}
                              style={{
                                  fontSize:'0.67rem',  
                                  textAlign: "left",
                                  backgroundColor: Structure.choch === true && Structure.slope > 1? '#9ce49c': ''
                                }}
                            
                            >{`${Structure.structure}`}</td>
                            <td style={{textAlign:'left'}} title={momentum_type}>{momentum_type?.charAt(0)}</td>
                            
                            <td>{(lastStockData?.breakout_price).toFixed(2)}</td>
                            {/* <td style={{background: isFarFromEMA20(todayLTP?.LTP, deliveryData?.EMA20)['status'] === true? "#f6fffc": parseInt(obj.is_buy) === 1 && moment(obj.buy_date).format("DD-MM-YYYY") === moment().format("DD-MM-YYYY")? "#fdd10c" : parseInt(obj.is_buy) === 1? "#fdef6f":"",}} 
                                title={`${isFarFromEMA20(todayLTP?.LTP, deliveryData?.EMA20)['ema_distance']}% ${parseInt(obj.is_buy) === 1? ` | ${moment(obj.buy_date).format("DD-MM-YYYY")} - ${setup_buy_price}`:'' }`}>
                              {obj.breakout_price}
                              
                              </td> */}


                              <td>{lastStockData?.low_price}</td>
                              <td>{(lastStockData?.close_price * 1.025).toFixed(2)}</td>
                              <td title={`${lastStockData?.open_price} | ${lastStockData?.high_price} | ${lastStockData?.low_price}`}>{lastStockData?.close_price}</td>
                              <td title={`${todayLTP?.OPEN} | ${todayLTP?.HIGH} | ${todayLTP?.LOW}`}>{todayLTP?.LTP}</td>
                              <td
                                style={{
                                  color:
                                    parseFloat(todayLTP?.CHANGEPER) > 0
                                      ? "#1c8b16"
                                      : "#f00",
                                }}
                              >
                                {todayLTP?.CHANGEPER}
                              </td>
                              <td style={{
                                  color:
                                    parseFloat(tchn_per) > 0
                                      ? "#1c8b16" 
                                      : parseFloat(tchn_per) === 0
                                      ? "#999" : "#f00",
                                }}>
                                  {tchn_per.toFixed(2)}%
                              </td>
                              <td

                                style={{
                                  textAlign: "right",
                                  background: EMA21Cross === true? "#e2ffe5":""
                                }}
                                title={`EMA20 > SMA20: ${deliveryData?.SMA20}`}
                              >
                                {deliveryData?.EMA20}
                              </td>
                              <td
                                style={{
                                  textAlign: "right",
                                  background:
                                    parseFloat(deliveryData?.SMA20) >
                                    parseFloat(deliveryData?.SMA50)
                                      ? "#e2ffe5"
                                      : "#fff8f8",
                                }}
                                title={`SMA20: ${deliveryData?.SMA20}`}
                              >
                                {deliveryData?.SMA50}
                              </td>
                            <td title={`${high52w} | ${highDate}`} 
                                style={{background:high52wPer >= 8 && high52wPer <=40 ? "" : "#fff6f6"}}>
                                {high52wPer.toFixed(2) + "%"}
                              </td>
                              <td title={`${lowDate} | ${highDate}`}>{`${low52w} | ${high52w}`}</td>
                              <td title={`${cuurVolPer.toFixed(2)}%` }
                                  style={{background: cuurVolPer > 25 ? "#e2ffe5" : ""}}
                              >
                                {Number(Prev_Volume).toLocaleString("en-IN")}
                              </td>
                              <td title={deliv > prevDeliv? `${prevDeliv}%`:''}
                                style={{background: deliv > prevDeliv? "#e2ffe5": ""}}
                              > 
                                {deliv}%</td>
                              <td style={{ textAlign: "center", padding:"0px"}}>
                                <button
                                  type="button"
                                  className="editlist"
                                  onClick={(e) => editItemHandler(e, obj, true)}
                                  title={`${obj.notes !== null || obj.notes !== ""? obj.notes : "Edit"}`}
                                ></button>
                              <a
                                title="News"
                                className="newsicon"
                                // href={`https://www.google.com/search?q=${symbolName}+stock+fundamental+analysis+latest+news+broker+report+target+price+intrinsic+value+prospects`}
                                // href={`https://www.google.com/search?q=NSE:${symbolName}+why+stock+is+rising+volume+spike+buy+or+sell`}
                                // href={`https://www.google.com/search?q=${symbolName}+NSE+EQ+stock+analysis+analyst+recommendation+future+growth+outlook`}
                                href={`https://www.google.com/ai?q=${AIPromptForStock1(symbolName)}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              ></a>
                              </td>
                              </tr>
                              )

                      })}

                      
                      {/* For BuyGTT List */} 
                      {trends === "All" && type === "Default" && searchText.length === 0 && todaysetupStatus?.BuyGTT?.length > 0 && (<tr key={`row_item_tr_16`}><td colSpan={25} style={{fontSize:"16px", fontWeight:'500', paddingTop:'15px', backgroundColor:'#F0F0F0'}}>Buy GTT  [{todaysetupStatus?.BuyGTT?.length}]</td></tr>)}
                       {trends === "All" && type === "Default" && searchText.length === 0 && todaysetupStatus?.BuyGTT && todaysetupStatus?.BuyGTT?.map((obj, index) => {
                        // console.log(obj);
                        let symbolName = obj.symbol;
   

                        let details = symbolData?.find((s) => s.symbol === symbolName);
                        let todayLTP = todayData?.find((s) => s.TICKER === symbolName);
                        
                        let deliverylist = Object.values(deliveryDataList);
                        let deliveryData = deliverylist?.find((s) => s.symbol === symbolName);
                        let EMA21Cross = parseFloat(deliveryData?.EMA20) > parseFloat(deliveryData?.SMA20);
                        
                        
                        let high52w = details?.high52w? details?.high52w: 0;
                        let low52w = details?.low52w? details?.low52w: 0;
                        let highDate = details?.highDate? moment(details?.highDate).format("DD-MM-YY"): "";
                        let lowDate = details?.lowDate? moment(details?.lowDate).format("DD-MM-YY"): "";
                        // let Structure = JSON.parse(obj?.structure_json || '[]');
                        let Structure = deliveryData?.structure_json || [];
                        let momentum_type = deliveryData?.momentum_type;   

                        let setup_buy_price = obj.portfolio_buy_price !== null? obj.portfolio_buy_price: obj.buy_price;

                        let tchn_per =   ((todayLTP?.LTP - setup_buy_price) * 100) / setup_buy_price;
                        
                        let rchn_per = parseFloat(setup_buy_price) > 0 ? ((todayLTP?.LTP - setup_buy_price) * 100) / setup_buy_price : ((todayLTP?.LTP - obj.close_price) * 100) / obj.close_price;
                       
                        let high52wPer = (((high52w - todayLTP?.LTP) * 100) / high52w);

                        let Volume = parseInt((moment(todayTime).isSame(todayLTP?.DATE, 'day')) && todayMarketHoldTime() === true? todayLTP?.VOLUME: deliveryData?.stock_data?.[0]?.ttl_trd_qty);
                        let Prev_Volume = parseInt((moment(todayTime).isSame(todayLTP?.DATE, 'day')) && todayMarketHoldTime() === true? deliveryData?.stock_data?.[0]?.ttl_trd_qty:deliveryData?.stock_data?.[1]?.ttl_trd_qty);

                        
                        let cuurVolPer = ((Volume - Prev_Volume) * 100) / Prev_Volume;

                        let prevDeliv = deliveryData?.stock_data?.[1]?.delivery_per;
                        let deliv = deliveryData?.stock_data?.[0]?.delivery_per;

                        let days = diffDays(moment(obj.buy_date).format('YYYY-MM-DD'), getUniqueDates?.[0]);

                        return (
                          <tr
                            className={`tr_${details?.id}`}
                            key={`row_item_b_${obj.id}`}
                            id={`row_item_b_${obj.id}`}
                          >
                          <td style={{fontSize:'11px'}}
                            title={days}
                          >{moment(obj.buy_date).format('DD-MM-YY')} </td>
                          <td 
                              className={`symbolName ${obj.in_portfolio === '1' && obj.is_triggered ===''? 'inpotfolio':''} ${obj.in_portfolio === '0' && obj.in_watchlist ==='1'? 'inwatchlist':''}`} 
                              style={{borderLeft: obj.verified === '1'? "3px solid #FF9800" : '', background: obj.today_occurred === moment().format('YYYY-MM-DD') && obj.occurance > 2? '#d3ffd5':''}}
                              title={(obj.today_occurred === moment().format('YYYY-MM-DD') && obj.occurance > 2? `[Occurance ${obj.occurance}] | ` : '')  +  (obj.in_portfolio === '1' && obj.is_triggered ===''? `Bought at: ${ moment(obj.portfolio_buy_date).format('DD-MM-YYYY')} - ${obj.portfolio_buy_price} [${obj.unit_qty}] ${obj.demat}` :  '')}
                          >
                              {symbolName}{" "}
                              {details?.hotStar === "1" ? (
                                <span className="hotStar"></span>
                              ) : null}


                              <span className="gttaction">
                                {parseInt(obj.gtt_SL) === 1 && <span className="gttSL"></span>}
                                {parseInt(obj.gtt_Target) === 1 && <span className="gttTarget"></span>}
                              </span>
                            </td>
                            <td>
                              <StockAction
                                symbol={symbolName}
                                delivery={false}
                                currentPrice={obj?.breakout_price}
                                deliveryPer={obj.delivery_per}
                                hotStar={details?.hotStar}
                                myFev={details?.myFev}
                                eventName={obj.setup}
                                slPrice={obj.sl_price}
                                gttPrice={obj.target_price}
                                rowId={`row_item_b_${obj.id}`}
                                score = {obj.score}
                              />
                            </td>
                            <td>
                              <DeliveryGraph
                                symbol={symbolName}
                                todayLTP={todayLTP}
                                date={getUniqueDates[0]}
                              />
                            </td>
                            <StockStrength
                              id={`del_${obj.id}`}
                              selectedDate={obj.delivery_date}
                              symbol={symbolName}
                              todayLTP={todayLTP}
                              details={details}
                            />
                            <SectorPanchang
                              symbol={symbolName}
                              sector={details?.group_sector}
                              todayData={todayData}
                              symbolData={symbolData}
                              tag = "td"
                              align = "right"
                              durationDays = ""
                            />
                            <td title={obj.score} style={{ textAlign: "left", background: obj?.todayScore > 70 ? "#72d083": obj?.todayScore > 60 ? "#ffec9c": "" }}>
                                {obj?.todayScore}
                              </td>
                              <td className="indices" style={{ textAlign: "left" }}>
                                {(() => {
                                  const label = details?.nifty50
                                    ? "50"
                                    : details?.nifty100
                                    ? "100"
                                    : details?.nifty200
                                    ? "200"
                                    : details?.nifty500
                                    ? "500"
                                    : details?.totalMarket
                                    ? "TM"
                                    : "";
                                  const excludedSeries = ["ETF", "BOND", "MF"];
                                  const showFev =
                                    details?.myFev &&
                                    !excludedSeries.includes(details?.series);
                                  return (
                                    label +
                                    (showFev ? `${label ? ", " : ""}Fev` : "")
                                  );
                                })()}
                              </td>
                            <td style={{textAlign: "left", lineHeight:1.2, background: Structure.slope < 1? "#ffcdcd" : 
                                    Structure.slope >= 3 && Structure.slope <= 5
                                      ? "#fff1ac" : Structure.slope > 5? "#9ce49c"
                                      : Structure.slope >= 3 && deliveryData.structure_json.slope > Structure.slope? "#0eb90e" : "", }}                                       
                                      title={`slope: ${Structure.slope} | confidence: ${Structure.confidence} - T slope: ${deliveryData.structure_json.slope} | T confidence: ${deliveryData.structure_json.confidence}`}
                            
                            >{obj.setup}
                            </td>
                            <td title={`If CHOCH true | lastHigh: ${Structure.lastHigh} | lastLow: ${Structure.lastLow} | prevHigh: ${Structure.prevHigh} | prevLow: ${Structure.prevLow}`}
                              style={{
                                  fontSize:'0.67rem',  
                                  textAlign: "left",
                                  backgroundColor: Structure.choch === true && Structure.slope > 1? '#9ce49c': ''
                                }}
                            
                            >{`${Structure.structure}`}</td>
                            <td style={{textAlign:'left'}} title={momentum_type}>{momentum_type?.charAt(0)}</td>
                            <td style={{background:  parseInt(obj.is_buy) !== 1 &&  isFarFromEMA20(todayLTP?.LTP, deliveryData?.EMA20)['status'] === true? "#f6fffc": parseInt(obj.is_buy) === 1 && moment(obj.buy_date).format("DD-MM-YYYY") === moment().format("DD-MM-YYYY")? "#fdd10c" : parseInt(obj.is_buy) === 1? "#fdef6f":"",}} 
                                title={`${isFarFromEMA20(todayLTP?.LTP, deliveryData?.EMA20)['ema_distance']}% ${parseInt(obj.is_buy) === 1? ` | ${moment(obj.buy_date).format("DD-MM-YYYY")} - ${setup_buy_price}`:'' }`}>
                              {obj.breakout_price}</td>
                              <td title={`${obj.is_triggered === "STOPLOSS"? moment(obj.triggered_date).format("DD-MM-YYYY") :"" }`}
                                    style={{
                                      textAlign: "right",
                                      background: obj.is_triggered === "STOPLOSS" && moment(obj.triggered_date).format("DD-MM-YYYY") === moment().format("DD-MM-YYYY")? "#ee1b1b" : obj.is_triggered === "STOPLOSS"? "#ffcbcb" : ""
                                      }}
                              >{obj.sl_price}</td>
                              <td title={`${obj.is_triggered === "TARGET"? moment(obj.triggered_date).format("DD-MM-YYYY") :"" }`}
                                    style={{
                                      textAlign: "right",
                                      background: obj.is_triggered === "TARGET" && moment(obj.triggered_date).format("DD-MM-YYYY") === moment().format("DD-MM-YYYY")? "#00a61c" : obj.is_triggered === "TARGET"? "#c2ffcc" : ""
                                      }}  
                              
                              >{obj.target_price}</td>
                              <td title={`${obj.open_price} | ${obj.high_price} | ${obj.low_price}`}>{obj.close_price}</td>
                              <td title={`${todayLTP?.OPEN} | ${todayLTP?.HIGH} | ${todayLTP?.LOW}`}>{todayLTP?.LTP}</td>
                              <td
                                style={{
                                  color:
                                    parseFloat(todayLTP?.CHANGEPER) > 0
                                      ? "#1c8b16"
                                      : "#f00",
                                }}
                              >
                                {todayLTP?.CHANGEPER}
                              </td>
                              <td style={{
                                  color:
                                    parseFloat(tchn_per) > 0
                                      ? "#1c8b16" 
                                      : parseFloat(tchn_per) === 0
                                      ? "#999" : "#f00",
                                }}>
                                  {parseFloat(tchn_per) !== 0 && `${parseFloat(tchn_per).toFixed(2)}`}
                                  
                              </td>
                              <td
                                style={{
                                  textAlign: "right",
                                  background: EMA21Cross === true? "#e2ffe5":""
                                }}
                                title={`EMA20 > SMA20: ${deliveryData?.SMA20}`}
                              >
                                {deliveryData?.EMA20}
                              </td>
                              <td
                                style={{
                                  textAlign: "right",
                                  background:
                                    parseFloat(deliveryData?.SMA20) >
                                    parseFloat(deliveryData?.SMA50)
                                      ? "#e2ffe5"
                                      : "#fff8f8",
                                }}
                                title={`SMA20: ${deliveryData?.SMA20}`}
                              >
                                {deliveryData?.SMA50}
                              </td>
                            <td title={`${high52w} | ${highDate}`} 
                                style={{background:high52wPer >= 8 && high52wPer <=40 ? "" : "#fff6f6"}}>
                                {high52wPer.toFixed(2) + "%"}
                              </td>
                              <td title={`${lowDate} | ${highDate}`}>{`${low52w} | ${high52w}`}</td>
                              <td title={`${cuurVolPer.toFixed(2)}%` }
                                  style={{background: cuurVolPer > 25 ? "#e2ffe5" : ""}}
                              >
                                {Number(Prev_Volume).toLocaleString("en-IN")}
                              </td>
                              <td title={deliv > prevDeliv? `${prevDeliv}%`:''}
                                style={{background: deliv > prevDeliv? "#e2ffe5": ""}}
                              > 
                                {deliv}%</td>
                              <td style={{ textAlign: "center", padding:"0px"}}>
                                <button
                                  type="button"
                                  className="editlist"
                                  onClick={(e) => editItemHandler(e, obj, true)}
                                  title={`${obj.notes !== null || obj.notes !== ""? obj.notes : "Edit"}`}
                                ></button>
                              <a
                                title="News"
                                className="newsicon"
                                // href={`https://www.google.com/search?q=${symbolName}+stock+fundamental+analysis+latest+news+broker+report+target+price+intrinsic+value+prospects`}
                                // href={`https://www.google.com/search?q=NSE:${symbolName}+why+stock+is+rising+volume+spike+buy+or+sell`}
                                // href={`https://www.google.com/search?q=${symbolName}+NSE+EQ+stock+analysis+analyst+recommendation+future+growth+outlook`}
                                href={`https://www.google.com/ai?q=${AIPromptForStock1(symbolName)}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              ></a>
                              </td>
                          </tr>
                        );
                      })}  

                      {/* For Days Exceeded List */} 
                      {trends === "All" && type === "Default" && searchText.length === 0 && todaysetupStatus?.DaysExceeded?.length > 0 && (<tr key={`row_item_tr_6`}><td colSpan={25} style={{fontSize:"16px", fontWeight:'500', paddingTop:'15px', backgroundColor:'#F0F0F0'}}>Days Exceeded  [{todaysetupStatus?.DaysExceeded?.length}]</td></tr>)}
                       {trends === "All" && type === "Default" && searchText.length === 0 && todaysetupStatus?.DaysExceeded && todaysetupStatus?.DaysExceeded?.map((obj, index) => {
                        // console.log(obj);
                        let symbolName = obj.symbol;
   

                        let details = symbolData?.find((s) => s.symbol === symbolName);
                        let todayLTP = todayData?.find((s) => s.TICKER === symbolName);
                        
                        let deliverylist = Object.values(deliveryDataList);
                        let deliveryData = deliverylist?.find((s) => s.symbol === symbolName);
                        let EMA21Cross = parseFloat(deliveryData?.EMA20) > parseFloat(deliveryData?.SMA20);
                        
                        
                        let high52w = details?.high52w? details?.high52w: 0;
                        let low52w = details?.low52w? details?.low52w: 0;
                        let highDate = details?.highDate? moment(details?.highDate).format("DD-MM-YY"): "";
                        let lowDate = details?.lowDate? moment(details?.lowDate).format("DD-MM-YY"): "";
                        // let Structure = JSON.parse(obj?.structure_json || '[]');
                        let Structure = deliveryData?.structure_json || [];
                        let momentum_type = deliveryData?.momentum_type;   

                        let setup_buy_price = obj.portfolio_buy_price !== null? obj.portfolio_buy_price: obj.buy_price;

                        let tchn_per =   ((todayLTP?.LTP - setup_buy_price) * 100) / setup_buy_price;
                        
                        let rchn_per = parseFloat(setup_buy_price) > 0 ? ((todayLTP?.LTP - setup_buy_price) * 100) / setup_buy_price : ((todayLTP?.LTP - obj.close_price) * 100) / obj.close_price;
                       
                        let high52wPer = (((high52w - todayLTP?.LTP) * 100) / high52w);

                        let Volume = parseInt((moment(todayTime).isSame(todayLTP?.DATE, 'day')) && todayMarketHoldTime() === true? todayLTP?.VOLUME: deliveryData?.stock_data?.[0]?.ttl_trd_qty);
                        let Prev_Volume = parseInt((moment(todayTime).isSame(todayLTP?.DATE, 'day')) && todayMarketHoldTime() === true? deliveryData?.stock_data?.[0]?.ttl_trd_qty:deliveryData?.stock_data?.[1]?.ttl_trd_qty);

                        
                        let cuurVolPer = ((Volume - Prev_Volume) * 100) / Prev_Volume;

                        let prevDeliv = deliveryData?.stock_data?.[1]?.delivery_per;
                        let deliv = deliveryData?.stock_data?.[0]?.delivery_per;

                        let days = diffDays(moment(obj.buy_date).format('YYYY-MM-DD'), getUniqueDates?.[0]);

                        return (
                          <tr
                            className={`tr_${details?.id}`}
                            key={`row_item_b_${obj.id}`}
                            id={`row_item_b_${obj.id}`}
                          >
                          <td style={{fontSize:'11px'}}
                            title={days}
                          >{moment(obj.buy_date).format('DD-MM-YY')} </td>
                          <td 
                              className={`symbolName ${obj.in_portfolio === '1' && obj.is_triggered ===''? 'inpotfolio':''} ${obj.in_portfolio === '0' && obj.in_watchlist ==='1'? 'inwatchlist':''}`} 
                              style={{borderLeft: obj.verified === '1'? "3px solid #FF9800" : '', background: obj.today_occurred === moment().format('YYYY-MM-DD') && obj.occurance > 2? '#d3ffd5':''}}
                              title={(obj.today_occurred === moment().format('YYYY-MM-DD') && obj.occurance > 2? `[Occurance ${obj.occurance}] | ` : '')  +  (obj.in_portfolio === '1' && obj.is_triggered ===''? `Bought at: ${ moment(obj.portfolio_buy_date).format('DD-MM-YYYY')} - ${obj.portfolio_buy_price} [${obj.unit_qty}] ${obj.demat}` :  '')}
                          >
                              {symbolName}{" "}
                              {details?.hotStar === "1" ? (
                                <span className="hotStar"></span>
                              ) : null}

                              <span className="gttaction">
                                {parseInt(obj.gtt_SL) === 1 && <span className="gttSL"></span>}
                                {parseInt(obj.gtt_Target) === 1 && <span className="gttTarget"></span>}
                              </span>
                            </td>
                            <td>
                              <StockAction
                                symbol={symbolName}
                                delivery={false}
                                currentPrice={obj?.breakout_price}
                                deliveryPer={obj.delivery_per}
                                hotStar={details?.hotStar}
                                myFev={details?.myFev}
                                eventName={obj.setup}
                                slPrice={obj.sl_price}
                                gttPrice={obj.target_price}
                                rowId={`row_item_b_${obj.id}`}
                                score = {obj.score}
                              />
                            </td>
                            <td>
                              <DeliveryGraph
                                symbol={symbolName}
                                todayLTP={todayLTP}
                                date={getUniqueDates[0]}
                              />
                            </td>
                            <StockStrength
                              id={`del_${obj.id}`}
                              selectedDate={obj.delivery_date}
                              symbol={symbolName}
                              todayLTP={todayLTP}
                              details={details}
                            />
                            <SectorPanchang
                              symbol={symbolName}
                              sector={details?.group_sector}
                              todayData={todayData}
                              symbolData={symbolData}
                              tag = "td"
                              align = "right"
                              durationDays = ""
                            />
                            <td title={obj.score} style={{ textAlign: "left", background: obj?.todayScore > 70 ? "#72d083": obj?.todayScore > 60 ? "#ffec9c": "" }}>
                                {obj?.todayScore}
                              </td>
                              <td className="indices" style={{ textAlign: "left" }}>
                                {(() => {
                                  const label = details?.nifty50
                                    ? "50"
                                    : details?.nifty100
                                    ? "100"
                                    : details?.nifty200
                                    ? "200"
                                    : details?.nifty500
                                    ? "500"
                                    : details?.totalMarket
                                    ? "TM"
                                    : "";
                                  const excludedSeries = ["ETF", "BOND", "MF"];
                                  const showFev =
                                    details?.myFev &&
                                    !excludedSeries.includes(details?.series);
                                  return (
                                    label +
                                    (showFev ? `${label ? ", " : ""}Fev` : "")
                                  );
                                })()}
                              </td>
                            <td style={{textAlign: "left", lineHeight:1.2, background: Structure.slope < 1? "#ffcdcd" : 
                                    Structure.slope >= 3 && Structure.slope <= 5
                                      ? "#fff1ac" : Structure.slope > 5? "#9ce49c"
                                      : Structure.slope >= 3 && deliveryData.structure_json.slope > Structure.slope? "#0eb90e" : "", }}                                       
                                      title={`slope: ${Structure.slope} | confidence: ${Structure.confidence} - T slope: ${deliveryData.structure_json.slope} | T confidence: ${deliveryData.structure_json.confidence}`}
                            
                            >{obj.setup}
                            </td>
                            <td title={`If CHOCH true | lastHigh: ${Structure.lastHigh} | lastLow: ${Structure.lastLow} | prevHigh: ${Structure.prevHigh} | prevLow: ${Structure.prevLow}`}
                              style={{
                                  fontSize:'0.67rem',  
                                  textAlign: "left",
                                  backgroundColor: Structure.choch === true && Structure.slope > 1? '#9ce49c': ''
                                }}
                            
                            >{`${Structure.structure}`}</td>
                            <td style={{textAlign:'left'}} title={momentum_type}>{momentum_type?.charAt(0)}</td>
                            <td style={{background:  parseInt(obj.is_buy) !== 1 &&  isFarFromEMA20(todayLTP?.LTP, deliveryData?.EMA20)['status'] === true? "#f6fffc": parseInt(obj.is_buy) === 1 && moment(obj.buy_date).format("DD-MM-YYYY") === moment().format("DD-MM-YYYY")? "#fdd10c" : parseInt(obj.is_buy) === 1? "#fdef6f":"",}} 
                                title={`${isFarFromEMA20(todayLTP?.LTP, deliveryData?.EMA20)['ema_distance']}% ${parseInt(obj.is_buy) === 1? ` | ${moment(obj.buy_date).format("DD-MM-YYYY")} - ${setup_buy_price}`:'' }`}>
                              {obj.breakout_price}</td>
                              <td title={`${obj.is_triggered === "STOPLOSS"? moment(obj.triggered_date).format("DD-MM-YYYY") :"" }`}
                                    style={{
                                      textAlign: "right",
                                      background: obj.is_triggered === "STOPLOSS" && moment(obj.triggered_date).format("DD-MM-YYYY") === moment().format("DD-MM-YYYY")? "#ee1b1b" : obj.is_triggered === "STOPLOSS"? "#ffcbcb" : ""
                                      }}
                              >{obj.sl_price}</td>
                              <td title={`${obj.is_triggered === "TARGET"? moment(obj.triggered_date).format("DD-MM-YYYY") :"" }`}
                                    style={{
                                      textAlign: "right",
                                      background: obj.is_triggered === "TARGET" && moment(obj.triggered_date).format("DD-MM-YYYY") === moment().format("DD-MM-YYYY")? "#00a61c" : obj.is_triggered === "TARGET"? "#c2ffcc" : ""
                                      }}  
                              
                              >{obj.target_price}</td>
                              <td title={`${obj.open_price} | ${obj.high_price} | ${obj.low_price}`}>{obj.close_price}</td>
                              <td title={`${todayLTP?.OPEN} | ${todayLTP?.HIGH} | ${todayLTP?.LOW}`}>{todayLTP?.LTP}</td>
                              <td
                                style={{
                                  color:
                                    parseFloat(todayLTP?.CHANGEPER) > 0
                                      ? "#1c8b16"
                                      : "#f00",
                                }}
                              >
                                {todayLTP?.CHANGEPER}
                              </td>
                              <td style={{
                                  color:
                                    parseFloat(tchn_per) > 0
                                      ? "#1c8b16" 
                                      : parseFloat(tchn_per) === 0
                                      ? "#999" : "#f00",
                                }}>
                                  {parseFloat(tchn_per) !== 0 && `${parseFloat(tchn_per).toFixed(2)}`}
                                  
                              </td>
                              <td
                                style={{
                                  textAlign: "right",
                                  background: EMA21Cross === true? "#e2ffe5":""
                                }}
                                title={`EMA20 > SMA20: ${deliveryData?.SMA20}`}
                              >
                                {deliveryData?.EMA20}
                              </td>
                              <td
                                style={{
                                  textAlign: "right",
                                  background:
                                    parseFloat(deliveryData?.SMA20) >
                                    parseFloat(deliveryData?.SMA50)
                                      ? "#e2ffe5"
                                      : "#fff8f8",
                                }}
                                title={`SMA20: ${deliveryData?.SMA20}`}
                              >
                                {deliveryData?.SMA50}
                              </td>
                            <td title={`${high52w} | ${highDate}`} 
                                style={{background:high52wPer >= 8 && high52wPer <=40 ? "" : "#fff6f6"}}>
                                {high52wPer.toFixed(2) + "%"}
                              </td>
                              <td title={`${lowDate} | ${highDate}`}>{`${low52w} | ${high52w}`}</td>
                              <td title={`${cuurVolPer.toFixed(2)}%` }
                                  style={{background: cuurVolPer > 25 ? "#e2ffe5" : ""}}
                              >
                                {Number(Prev_Volume).toLocaleString("en-IN")}
                              </td>
                              <td title={deliv > prevDeliv? `${prevDeliv}%`:''}
                                style={{background: deliv > prevDeliv? "#e2ffe5": ""}}
                              > 
                                {deliv}%</td>
                              <td style={{ textAlign: "center", padding:"0px"}}>
                                <button
                                  type="button"
                                  className="editlist"
                                  onClick={(e) => editItemHandler(e, obj, true)}
                                  title={`${obj.notes !== null || obj.notes !== ""? obj.notes : "Edit"}`}
                                ></button>
                              <a
                                title="News"
                                className="newsicon"
                                // href={`https://www.google.com/search?q=${symbolName}+stock+fundamental+analysis+latest+news+broker+report+target+price+intrinsic+value+prospects`}
                                // href={`https://www.google.com/search?q=NSE:${symbolName}+why+stock+is+rising+volume+spike+buy+or+sell`}
                                // href={`https://www.google.com/search?q=${symbolName}+NSE+EQ+stock+analysis+analyst+recommendation+future+growth+outlook`}
                                href={`https://www.google.com/ai?q=${AIPromptForStock1(symbolName)}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              ></a>
                              </td>
                          </tr>
                        );
                      })}  
                    </tbody>
                  </table>
                  
                  <div className="container-fluid py-4">
                    <div className="row equal-height-row">
                      {Object.entries(triggerStats).length > 1?
                              <div className="col-4 col-md px-1 mb-2">
                                    <div className="border setupstats">
                                        <div>All</div>
                                        <div><strong>Target:</strong> {triggerTGCount}</div>
                                        <div><strong>SL:</strong> {triggerSLCount}</div>
                                        <div><strong>Total:</strong> {triggerCount}</div>
                                      </div>
                                </div>
                        : ''}
                        {Object.entries(triggerStats)
                        .sort((a, b) => b[1].total - a[1].total)
                        .map(([setup, stats], item) => {
                            return(
                                <div className="col-4 col-md px-1 mb-2" key={item}>
                                    <div className="border setupstats">
                                        <div>{setup}</div>
                                        <div><strong>Target:</strong> {stats.targetCount}</div>
                                        <div><strong>SL:</strong> {stats.stopLossCount}</div>
                                        <div><strong>Total:</strong> {stats.total}</div>
                                      </div>
                                </div>
                            )

                        })}
                    </div>
                    <div className="row py-2">
                          <div className="col px-1 ms-0 flex-grow-0" style={{minWidth: '200px'}}>
                                    <div className="border setupstats">
                                        <div>SETUP PL</div>
                                        <div><strong>Target: </strong>
                                        {(Object.values(triggerStats || {}).reduce(
                                          (sum, item) => sum + Number(item.totalTarget || 0),
                                          0
                                        )).toFixed(2)}
                                         %</div>
                                        <div><strong>SL: </strong>
                                        {(Object.values(triggerStats || {}).reduce(
                                          (sum, item) => sum + Number(item.totalSL || 0),
                                          0
                                        )).toFixed(2)}
                                         %</div>
                                        <div><strong>Total:</strong>
                                        {
                                          Object.values(triggerStats || {})
                                            .reduce(
                                              (sum, item) =>
                                                sum + Number(item.totalTarget || 0) + Number(item.totalSL || 0),
                                              0
                                            )
                                            .toFixed(2)
                                        }
                                         %</div>
                                        <div style={{ margin:'6px 0px', borderTop:'solid 1px #ddd'}}><strong>UPComing[{upcomingPLCount}] :</strong> {(Object.values(triggerStats || {}).reduce(
                                          (sum, item) => sum + Number(item.upcomingPL || 0),
                                          0
                                        )).toFixed(2)}
                                        %</div>
                                      </div>
                          </div>

                          <div className="col px-1 ms-0 flex-grow-0" style={{minWidth: '200px'}}>
                                    <div className="border setupstats">
                                        <div>MONTH PL</div>
                                        <div>
                                          <strong>Target: </strong>
                                          [{getMonthPL.targetQty}]   {getMonthPL.target}%
                                        </div>
                                        <div>
                                          <strong>SL: </strong>
                                          [{getMonthPL.slQty}]  {getMonthPL.sl}%
                                        </div>
                                        <div>
                                          <strong>Total:</strong>
                                          {getMonthPL.total}%
                                        </div>
                                        <div style={{ margin:'6px 0px', borderTop:'solid 1px #ddd'}}>
                                          <strong>UPComing[{getMonthPL.upcomingQty}] : </strong> 
                                          &nbsp;{getMonthPL.upcoming}%
                                        </div>
                                      </div>
                          </div>
                    </div>
                  </div>
              </>
            </div>
          )}
        </React.Fragment>
      </div>

{/* ########################## Modal for Buy/update ################################ */}
       <Modal
            show = {modalShow}
            onHide={() => setModalShow(false)}
            // fullscreen = {true}
            dialogClassName = "watchlist-details"
            // backdrop="static"
            // keyboard={false}
            centered
        >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
            <form onSubmit={(e) => updateItemHandler(e, paramsMeta)}>
            <div className="row p-3">
                    <div className="col-8 mb-3">{`${paramsMeta.symbol} ${paramsMeta.setup} `}  | LTP:- { todayData?.find((s) => s.TICKER === paramsMeta.symbol)?.['LTP']}

                      <div className="d-inline"> | Fair Price                        
                      {`[${getFairBuyPrice(paramsMeta)?.status} - ${getFairBuyPrice(paramsMeta)?.emaDistance}%] - ${getFairBuyPrice(paramsMeta)?.buyPrice}`} </div>

                    </div>

                    <div className="col-3 text-danger small">{toastShown}</div>           
                   <div className="col-1">           
                            <div className="modalStockAcion" style={{right:'10px', top:'20px'}}>
                                <StockAction
                                  symbol={paramsMeta.symbol}
                                  delivery={false}
                                  // currentPrice ={todayLTP?.LTP?.toFixed(2)}
                                  // deliveryPer={getDeliverData[0].delivery_per}
                                  // hotStar={obj.details?.hotStar} myFev={obj.details?.myFev}
                                  // eventName = {trends===''?'Delivery':trends} rowId=""
                                />
                            </div>
                      </div>
                    
                    <div className="col-auto text-start pt-2">
                        <input style={{width: '18px', height: "18px"}} name="rejectStock" id="rejectStock" type="checkbox" defaultChecked={Number(paramsMeta?.reject_stock) === 1} /> 
                        <label htmlFor="rejectStock" style={{position:"relative", top:"-4px", paddingLeft: "5px"}}>Reject Stock</label>
                    </div>
                    
                    <div className="col">
                            <div className="form-floating">
                                    <input type="text" className="form-control" name="buyprice" id="buyprice" placeholder="Buy Price" 
                                    value={newBuyPrice || ""}
                                    onChange={(e) => setNewBuyPrice(e.target.value)}
                                    onKeyPress={(event) => checkInputVal(event)}
                                    />
                                    <label htmlFor="buyprice">Buy Price <span>{paramsMeta.breakout_price}</span></label>
                            </div>
                    </div>
                    <div className="col pe-0">
                            <div className="form-floating">
                                <input type="text" className="form-control" name="sl" id="sl" placeholder="SL" 
                                value={newSLPrice || ""}
                                onChange={(e) => setNewSLPrice(e.target.value)}
                                onKeyPress={(event) => checkInputVal (event)}
                                />
                                <label htmlFor="sl">SL  <span>{paramsMeta.sl_price} ({(((newBuyPrice - newSLPrice) * 100)/newSLPrice).toFixed(2)}%)</span></label>
                            </div>
                    </div>
                    <div className="col pe-0">
                            <div className="form-floating">
                                <input type="text" className="form-control" name="target" id="target" placeholder="Target" 
                                value={newTargetPrice || ""}
                                onChange={(e) => setNewTargetPrice(e.target.value)}
                                onKeyPress={(event) => checkInputVal (event)}
                                />
                                <label htmlFor="target">Target <span>{paramsMeta.target_price} ({(((newTargetPrice - newBuyPrice) * 100)/newBuyPrice).toFixed(2)}%)</span></label>
                            </div>
                    </div>
                    <div className="col">
                        <div className="form-floating">
                          <select
                            className="form-control"
                            id="mtrends"
                            defaultValue={paramsMeta.setup}
                            // onChange={e => setTrends(e.target.value)}
                          >
                            <option value="All">All</option>
                            {getUniqueSetups?.map((item) => (
                              <option key={item} value={item}>
                                {item}
                              </option>
                            ))}
                          </select>
                          <label htmlFor="mtrends">Trends</label>
                        </div>
                      </div>
                    <div className="col">
                       <div className="form-floating">
                        <DatePicker 
                                        placeholderText={'Select date'}
                                        className="form-control"
                                        selected={verifyDate} 
                                        onChange={(date) => setVerifyDate(date)}
                                        dateFormat="dd/MM/YYYY"
                                        minDate={isTodayBreakout !== true? paramsMeta.breakout_date: paramsMeta.delivery_date}
                                        maxDate={todayTime}
                                        filterDate={isWeekdayAllowed}
                                     />


                            <label htmlFor="target" className="show" style={{ color: '#888'}}>Verified Date</label>
                            </div>
                    </div>
                    
            </div>
            
                {symbolInBasket && symbolInBasket.length > 0 && (
                    <div className="px-3">
                      <table className="symbolInBasket">
                        <thead>
                          <tr key={`row_item_tr_5`}>
                            <th width="65px">Date</th>
                            <th width="70px">Close Price</th>
                            <th width="65px">Buy Price</th>
                            <th width="110px">SL</th>
                            <th width="110px">Traget</th>
                            <th width="105px" style={{textAlign:'left'}}>Setup</th>
                            <th style={{textAlign:'left'}}>Notes</th>
                            <th width="10px">
                              <a
                                title="News"
                                className="newsicon"
                                href={`https://www.google.com/ai?q=${AIPromptForStockPL(paramsMeta.symbol)}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              ></a>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {symbolInBasket.map((item, index) => {
                            // console.log("item", item)
                            let is_SLHits =  parseInt(item.is_buy) === 1 && item.is_triggered === "STOPLOSS"? true:false;
                            let is_TargetHits = item.is_buy === "1" && item.is_triggered === "TARGET"? true:false;
                            let isTradeClosed = is_SLHits || is_TargetHits;
                            let isVerify = parseInt(item.verified);
                            let isBuy =  parseInt(item.is_buy);
                            let is_rejected = parseInt(item.reject_stock);
                           return (
                            <tr key={`row_1_${index}`} id={`item_id_${item.id}`} style={{background: is_rejected === 1? '#ffc3c3' : is_SLHits? "#fffbfb" : is_TargetHits? "#f3fff4":"",  }}>
                              <td style={{'border-left': isVerify? '3px solid rgb(255, 152, 0)' : ''}}>{isTradeClosed? moment(item.breakout_date).format('DD-MM-YY'):                                
                                <button type="button" className="p-0 border-0" style={{background:"none"}}  onClick={(e) => editItemHandler(e, item, false)}>{moment(item.breakout_date).format('DD-MM-YY')}</button>
                                }</td>
                              <td>{item.close_price}</td>
                              <td style={{'border-left': isBuy? '3px solid rgb(255, 152, 0)' : ''}}>{item.breakout_price}</td>
                              <td>{item.sl_price}{" "} ({(((paramsMeta.breakout_price - newSLPrice) * 100)/newSLPrice).toFixed(2)}%)</td>
                              <td>{item.target_price}{" "} ({(((newTargetPrice - paramsMeta.breakout_price) * 100)/paramsMeta.breakout_price).toFixed(2)}%)</td>
                              <td style={{textAlign:'left'}}>{item.setup}</td>
                              <td style={{textAlign:'left'}}>{item.notes}</td>
                              <td>
                                {(!(isSameDate(item.breakout_date, paramsMeta.breakout_date) && item.setup === paramsMeta.setup && item.verified === '1') || symbolInBasket.length == 1) && !isTradeClosed  && 
                                
                                    (<button type="button" className="removelist" onClick={(e) => removeItemHandler(e, item.id)}  />
                                )}
                              </td>
                            </tr>
                          )})}
                        </tbody>
                      </table>
                      </div>
                    )}

              
            <div className="row">
                <div className="col-md-12 px-4 mt-2">
                        <div className="form-floating">
                            <input type="text" className="form-control" name="notes" id="notes" placeholder="Notes" 
                            value={newNotes || ""}
                            onChange={(e) => setNewNotes(e.target.value)}
                            />
                            <label htmlFor="notes">Notes</label>
                        </div>
                </div>
                
                <div className="py-3 col-3 text-start">
                    <input className="ms-3" style={{width: '18px', height: "18px"}} name="todayBreakout" id="todayBreakout" type="checkbox" onChange={(e) => updateHandlerType(e)}  /> 
                    <label htmlFor="todayBreakout" style={{position:"relative", top:"-4px", paddingLeft: "5px"}}>Today Breakout</label>
                </div>

                <div className="py-3 col-3 text-start">
                    <input style={{width: '18px', height: "18px"}} name="resetPrice" id="resetPrice" type="checkbox" onChange={(e) => updateHandlerType(e)}  /> 
                    <label htmlFor="resetPrice" style={{position:"relative", top:"-4px", paddingLeft: "5px"}}>Reset Price</label>
                </div>


                {Number(paramsMeta.is_buy) === 1?
                <div className="py-3 col-3 text-start">
                    <input style={{width: '18px', height: "18px"}} name="buyGTT" id="buyGTT" type="checkbox" defaultChecked={Number(paramsMeta?.is_buy_GTT) === 1}  /> 
                    <label htmlFor="buyGTT" style={{position:"relative", top:"-4px", paddingLeft: "5px"}}>BUY GTT</label>
                </div>
                :''}

                <div className="py-3 col-6 text-end">
                        <button type="submit" className="btn btn-outline-primary px-4 me-3">UPDATE</button>
                    </div>
            </div>
            </form>

            
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};
export default TrendsSetupPage;
